"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconUpload = exports.IconUnfocus = exports.IconUndo = exports.IconUnderline = exports.IconThumbUp = exports.IconThumbUpFill = exports.IconThumbDown = exports.IconThumbDownFill = exports.IconTablet = exports.IconSettings = exports.IconReset = exports.IconRefresh = exports.IconRedo = exports.IconPrinter = exports.IconPlay = exports.IconPhone = exports.IconPerson = exports.IconPencil = exports.IconPadlock = exports.IconMoreVertical = exports.IconMoreHorizontal = exports.IconMobile = exports.IconMenu = exports.IconMail = exports.IconJumpToContent = exports.IconItalic = exports.IconHourGlass = exports.IconHome = exports.IconGlobe = exports.IconFocus = exports.IconDownload = exports.IconDisabled = exports.IconDesktop = exports.IconCheck = exports.IconCalendar = exports.IconBold = exports.IconBin = exports.IconBackToTop = exports.IconArrowRight = exports.IconArrowLeft = exports.IconAnchorLink = exports.IconTick = exports.IconStar = exports.IconStarFill = exports.IconSort = exports.IconSortDescending = exports.IconSortAscending = exports.IconSearch = exports.IconQuestionCircle = exports.IconPlus = exports.IconPlusCircle = exports.IconPayment = exports.IconPaymentFill = exports.IconPadlockFill = exports.IconNotification = exports.IconNotificationFill = exports.IconMinus = exports.IconInformation = exports.IconInformationFill = exports.IconHeart = exports.IconHeartFill = exports.IconExternalLink = exports.IconDoubleChevronRight = exports.IconDoubleChevronLeft = exports.IconDocument = exports.IconCross = exports.IconCrossInsideCircle = exports.IconCopy = exports.IconCloseCircleFill = exports.IconClock = exports.IconClockFill = exports.IconChevronUp = exports.IconChevronRight = exports.IconChevronLeft = exports.IconChevronDown = exports.IconCheckCircleFill = exports.IconAlert = exports.IconAlertTriangleFill = exports.IconAlertCircleFill = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("./createSvg");

var _interfaces = require("./interfaces");

var _ref, _ref2, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref11, _ref12, _ref14, _ref18, _ref19, _ref20, _ref21, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37;

var IconAlertCircleFill = (0, _createSvg.createSvg)('IconAlertCircleFill', new _interfaces.SVGIconWithSizes((_ref = {}, (0, _defineProperty2.default)(_ref, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm.92,13.38a1.15,1.15,0,0,1-.21.33,1.15,1.15,0,0,1-.33.21.94.94,0,0,1-.76,0,.9.9,0,0,1-.54-.54.94.94,0,0,1,0-.76,1,1,0,0,1,.21-.33,1.15,1.15,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1,1,0,0,1,.21.33.94.94,0,0,1,0,.76ZM9,9A1,1,0,0,1,7,9V3A1,1,0,0,1,9,3Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref, _interfaces.IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm.71,17a1,1,0,0,1-1.42,0,1.15,1.15,0,0,1-.21-.33A1,1,0,0,1,9,16.25a1.05,1.05,0,0,1,.29-.71l.15-.12.18-.09.18-.06a.9.9,0,0,1,.4,0l.18.06.18.09.15.12a1,1,0,0,1,.21.33A1,1,0,0,1,10.71,17ZM11,11.25a1,1,0,0,1-2,0V3.75a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref, _interfaces.IconSize.Medium, {
  paths: ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm.71,20.21a1,1,0,0,1-1.09.21,1.15,1.15,0,0,1-.33-.21A1,1,0,0,1,11,19.5a1.05,1.05,0,0,1,.29-.71.93.93,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.05,1.05,0,0,1,.29.71A1,1,0,0,1,12.71,20.21ZM13,13.5a1,1,0,0,1-2,0v-9a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref, _interfaces.IconSize.Large, {
  paths: ['M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm.92,25.38a1.15,1.15,0,0,1-.21.33,1,1,0,0,1-.33.21A1,1,0,0,1,15,25a.84.84,0,0,1,.08-.38.9.9,0,0,1,.54-.54.93.93,0,0,1,.57-.06.6.6,0,0,1,.19.06.76.76,0,0,1,.18.09,1.58,1.58,0,0,1,.15.12,1,1,0,0,1,.21.33.94.94,0,0,1,0,.76ZM17,19a1,1,0,0,1-2,0V7a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref)));
exports.IconAlertCircleFill = IconAlertCircleFill;
var IconAlertTriangleFill = (0, _createSvg.createSvg)('IconAlertTriangleFill', new _interfaces.SVGIconWithSizes((_ref2 = {}, (0, _defineProperty2.default)(_ref2, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15.86,14.51A1,1,0,0,1,15,15H1a1,1,0,0,1-.88-1.47l7-13a1,1,0,0,1,1.76,0l7,13A1,1,0,0,1,15.86,14.51ZM9,8.48v-4a1,1,0,0,0-2,0v4a1,1,0,0,0,2,0Zm-.29,4.67a1,1,0,0,0,.21-.33.94.94,0,0,0,0-.76,1,1,0,0,0-.21-.32,1,1,0,0,0-1.42,0,1,1,0,0,0-.21,1.08,1,1,0,0,0,.21.33,1.19,1.19,0,0,0,.33.22,1,1,0,0,0,1.09-.22Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref2, _interfaces.IconSize.Small, {
  paths: ['M19.78,17.89,10.78,1A.92.92,0,0,0,9.22,1l-9,16.87a.89.89,0,0,0,0,.88A.88.88,0,0,0,1,19.2H19a.88.88,0,0,0,.76-.43A.89.89,0,0,0,19.78,17.89ZM10.71,17a1.19,1.19,0,0,1-.33.22A1,1,0,0,1,9.29,15.6a1,1,0,0,1,1.09-.22.83.83,0,0,1,.33.22,1,1,0,0,1,0,1.41ZM11,12.16a1,1,0,0,1-2,0V7a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref2, _interfaces.IconSize.Medium, {
  paths: ['M 23.167969 21.40625 L 12.667969 1.15625 C 12.539062 0.90625 12.28125 0.746094 12 0.746094 C 11.71875 0.746094 11.460938 0.90625 11.332031 1.15625 L 0.832031 21.40625 C 0.710938 21.636719 0.722656 21.917969 0.859375 22.140625 C 0.996094 22.363281 1.238281 22.5 1.5 22.5 L 22.5 22.5 C 22.761719 22.5 23.003906 22.363281 23.140625 22.140625 C 23.277344 21.917969 23.289062 21.636719 23.167969 21.40625 Z M 12.539062 20.039062 C 12.46875 20.109375 12.382812 20.164062 12.292969 20.203125 C 12.199219 20.242188 12.101562 20.257812 12 20.25 C 11.585938 20.25 11.25 19.914062 11.25 19.5 C 11.25 19.398438 11.273438 19.300781 11.308594 19.207031 C 11.347656 19.117188 11.402344 19.03125 11.46875 18.960938 C 11.539062 18.886719 11.625 18.832031 11.722656 18.796875 C 11.859375 18.738281 12.007812 18.722656 12.148438 18.75 C 12.199219 18.757812 12.246094 18.773438 12.292969 18.796875 C 12.339844 18.808594 12.382812 18.835938 12.421875 18.871094 L 12.539062 18.960938 C 12.609375 19.03125 12.667969 19.113281 12.703125 19.207031 C 12.738281 19.300781 12.753906 19.402344 12.75 19.5 C 12.753906 19.699219 12.679688 19.894531 12.539062 20.039062 Z M 12.75 15 C 12.75 15.414062 12.414062 15.75 12 15.75 C 11.585938 15.75 11.25 15.414062 11.25 15 L 11.25 7.5 C 11.25 7.085938 11.585938 6.75 12 6.75 C 12.414062 6.75 12.75 7.085938 12.75 7.5 Z M 12.75 15'],
  params: {
    width: '32',
    height: '32',
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref2, _interfaces.IconSize.Large, {
  paths: ['M30.89,28.54l-14-27a1,1,0,0,0-1.78,0l-14,27A1,1,0,0,0,2,30H30a1,1,0,0,0,.89-1.46ZM16.72,26.72a1.19,1.19,0,0,1-.33.22A.88.88,0,0,1,16,27a1,1,0,0,1-1-1,1.09,1.09,0,0,1,.08-.39,1.15,1.15,0,0,1,.21-.33.91.91,0,0,1,.34-.22A1,1,0,0,1,16.2,25a.6.6,0,0,1,.19.06.42.42,0,0,1,.17.1l.16.12a1,1,0,0,1,.22.33A1.09,1.09,0,0,1,17,26,1,1,0,0,1,16.72,26.72ZM17,20a1,1,0,1,1-2,0V10a1,1,0,1,1,2,0Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref2)));
exports.IconAlertTriangleFill = IconAlertTriangleFill;
var IconAlert = (0, _createSvg.createSvg)('IconAlert', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,2a.8.8,0,0,1,.7.4l5.2,10.4a.8.8,0,0,1-.7,1.2H2.8a.8.8,0,0,1-.7-1.2L7.3,2.5A.8.8,0,0,1,8,2M8,0A2.8,2.8,0,0,0,5.5,1.6L.3,11.9A2.8,2.8,0,0,0,2.8,16H13.2a2.8,2.8,0,0,0,2.5-4.1L10.5,1.6A2.8,2.8,0,0,0,8,0ZM9,9A1,1,0,1,1,7,9V5A1,1,0,0,1,9,5Zm0,3.4a1,1,0,1,1-1-1A1,1,0,0,1,9,12.4Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconAlert = IconAlert;
var IconCheckCircleFill = (0, _createSvg.createSvg)('IconCheckCircleFill', new _interfaces.SVGIconWithSizes((_ref4 = {}, (0, _defineProperty2.default)(_ref4, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4.77,5.64-5,6a1,1,0,0,1-.72.36H7a1,1,0,0,1-.71-.29l-3-3A1,1,0,1,1,4.71,7.29L6.93,9.52l4.3-5.16a1,1,0,1,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref4, _interfaces.IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm5.77,6.89-6.25,7.5a1,1,0,0,1-.73.36h0A1,1,0,0,1,8,14.46L4.29,10.71A1,1,0,0,1,5.71,9.29l3,3,5.55-6.66a1,1,0,0,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref4, _interfaces.IconSize.Medium, {
  paths: ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6.77,8.14-7.5,9a1,1,0,0,1-.73.36h0a1,1,0,0,1-.71-.29l-4.5-4.5a1,1,0,0,1,1.42-1.42L10.43,15l6.8-8.16a1,1,0,0,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref4, _interfaces.IconSize.Large, {
  paths: ['M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm8.77,10.64-10,12A1,1,0,0,1,14,23h0a1,1,0,0,1-.71-.29l-6-6a1,1,0,1,1,1.42-1.42l5.22,5.23,9.3-11.16a1,1,0,0,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref4)));
exports.IconCheckCircleFill = IconCheckCircleFill;
var IconChevronDown = (0, _createSvg.createSvg)('IconChevronDown', new _interfaces.SVGIconWithSizes((_ref5 = {}, (0, _defineProperty2.default)(_ref5, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3,6a1,1,0,0,1,1.7-.7L8,8.6l3.3-3.3a1,1,0,0,1,1.4,1.4l-4,4a1,1,0,0,1-1.4,0l-4-4A1,1,0,0,1,3,6Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref5, _interfaces.IconSize.Small, {
  paths: ['M3.29325,7.70725 C2.90225,7.31625 2.90225,6.68425 3.29325,6.29325 C3.48825,6.09825 3.74425,6.00025 4.00025,6.00025 C4.25625,6.00025 4.51225,6.09825 4.70725,6.29325 L10.00025,11.58625 L15.29325,6.29325 C15.68425,5.90225 16.31625,5.90225 16.70725,6.29325 C17.09825,6.68425 17.09825,7.31625 16.70725,7.70725 L10.70725,13.70725 C10.31625,14.09825 9.68425,14.09825 9.29325,13.70725 L3.29325,7.70725 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref5)));
exports.IconChevronDown = IconChevronDown;
var IconChevronLeft = (0, _createSvg.createSvg)('IconChevronLeft', new _interfaces.SVGIconWithSizes((_ref6 = {}, (0, _defineProperty2.default)(_ref6, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10,13a1,1,0,0,1-.71-.29l-4-4a1,1,0,0,1,0-1.42l4-4a1,1,0,1,1,1.42,1.42L7.41,8l3.3,3.29a1,1,0,0,1,0,1.42A1,1,0,0,1,10,13Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref6, _interfaces.IconSize.Small, {
  paths: ['M8.41425,10.00025 L13.70725,4.70725 C14.09825,4.31625 14.09825,3.68425 13.70725,3.29325 C13.31625,2.90225 12.68425,2.90225 12.29325,3.29325 L6.29325,9.29325 C5.90225,9.68425 5.90225,10.31625 6.29325,10.70725 L12.29325,16.70725 C12.48825,16.90225 12.74425,17.00025 13.00025,17.00025 C13.25625,17.00025 13.51225,16.90225 13.70725,16.70725 C14.09825,16.31625 14.09825,15.68425 13.70725,15.29325 L8.41425,10.00025 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref6)));
exports.IconChevronLeft = IconChevronLeft;
var IconChevronRight = (0, _createSvg.createSvg)('IconChevronRight', new _interfaces.SVGIconWithSizes((_ref7 = {}, (0, _defineProperty2.default)(_ref7, _interfaces.IconSize.ExtraSmall, {
  paths: ['M6,13a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L8.59,8,5.29,4.71A1,1,0,0,1,6.71,3.29l4,4a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,6,13Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref7, _interfaces.IconSize.Small, {
  paths: ['M11.58625,10 L6.29325,4.707 C5.90225,4.316 5.90225,3.684 6.29325,3.293 C6.48825,3.098 6.74425,3 7.00025,3 C7.25625,3 7.51225,3.098 7.70725,3.293 L13.70725,9.293 C14.09825,9.684 14.09825,10.316 13.70725,10.707 L7.70725,16.707 C7.31625,17.098 6.68425,17.098 6.29325,16.707 C5.90225,16.316 5.90225,15.684 6.29325,15.293 L11.58625,10 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref7)));
exports.IconChevronRight = IconChevronRight;
var IconChevronUp = (0, _createSvg.createSvg)('IconChevronUp', new _interfaces.SVGIconWithSizes((_ref8 = {}, (0, _defineProperty2.default)(_ref8, _interfaces.IconSize.ExtraSmall, {
  paths: ['M13,10a1,1,0,0,1-1.7.7L8,7.4,4.7,10.7A1,1,0,0,1,3.3,9.3l4-4a1,1,0,0,1,1.4,0l4,4A1,1,0,0,1,13,10Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref8, _interfaces.IconSize.Small, {
  paths: ['M16.70725,12.29325 L10.70725,6.29325 C10.31625,5.90225 9.68425,5.90225 9.29325,6.29325 L3.29325,12.29325 C2.90225,12.68425 2.90225,13.31625 3.29325,13.70725 C3.68425,14.09825 4.31625,14.09825 4.70725,13.70725 L10.00025,8.41425 L15.29325,13.70725 C15.48825,13.90225 15.74425,14.00025 16.00025,14.00025 C16.25625,14.00025 16.51225,13.90225 16.70725,13.70725 C17.09825,13.31625 17.09825,12.68425 16.70725,12.29325'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref8)));
exports.IconChevronUp = IconChevronUp;
var IconClockFill = (0, _createSvg.createSvg)('IconClockFill', new _interfaces.SVGIconWithSizes((_ref9 = {}, (0, _defineProperty2.default)(_ref9, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,8A1,1,0,0,1,8,9H3.76a1,1,0,0,1,0-2H7V3.76a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref9, _interfaces.IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm1,10a1,1,0,0,1-1,1H4.7a1,1,0,1,1,0-2H9V4.7a1,1,0,1,1,2,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _ref9)));
exports.IconClockFill = IconClockFill;
var IconClock = (0, _createSvg.createSvg)('IconClock', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,2A6,6,0,1,1,2,8,6,6,0,0,1,8,2M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM7.9,3a1,1,0,0,0-1,1V7h-3a1,1,0,0,0,0,2h4a1,1,0,0,0,1-1V4A1,1,0,0,0,7.9,3Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconClock = IconClock;
var IconCloseCircleFill = (0, _createSvg.createSvg)('IconCloseCircleFill', new _interfaces.SVGIconWithSizes((_ref11 = {}, (0, _defineProperty2.default)(_ref11, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.71,10.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L8,9.41l-2.29,2.3a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L6.59,8,4.29,5.71A1,1,0,0,1,5.71,4.29L8,6.59l2.29-2.3a1,1,0,1,1,1.42,1.42L9.41,8Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref11, _interfaces.IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.46,13a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0l-3-3.05L7,14.46a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42l3.05-3-3-3A1,1,0,0,1,7,5.54l3,3.05,3-3A1,1,0,1,1,14.46,7l-3.05,3Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref11, _interfaces.IconSize.Medium, {
  paths: ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5.2,15.78a1,1,0,0,1-.71,1.71,1,1,0,0,1-.71-.3L12,13.41,8.2,17.2a1,1,0,0,1-.71.3,1,1,0,0,1-.71-.3,1,1,0,0,1,0-1.41L10.57,12,6.78,8.21a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0L12,10.59,15.77,6.8a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41L13.4,12Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref11, _interfaces.IconSize.Large, {
  paths: ['M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm6.71,21.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L16,17.41l-5.29,5.3a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L14.59,16l-5.3-5.29a1,1,0,0,1,1.42-1.42L16,14.59l5.29-5.3a1,1,0,0,1,1.42,1.42L17.41,16Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref11)));
exports.IconCloseCircleFill = IconCloseCircleFill;
var IconCopy = (0, _createSvg.createSvg)('IconCopy', new _interfaces.SVGIconWithSizes((_ref12 = {}, (0, _defineProperty2.default)(_ref12, _interfaces.IconSize.ExtraSmall, {
  paths: ['M14,0H6A1,1,0,0,0,5,1V4H2A1,1,0,0,0,1,5V15a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V12h3a1,1,0,0,0,1-1V1A1,1,0,0,0,14,0ZM9,14H3V6H9Zm4-4H11V5a1,1,0,0,0-1-1H7V2h6Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref12, _interfaces.IconSize.Small, {
  paths: ['M16,1H8A1,1,0,0,0,7,2V5H4A1,1,0,0,0,3,6V18a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V15h3a1,1,0,0,0,1-1V2A1,1,0,0,0,16,1ZM11,17H5V7h6Zm4-4H13V6a1,1,0,0,0-1-1H9V3h6Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _ref12)));
exports.IconCopy = IconCopy;
var IconCrossInsideCircle = (0, _createSvg.createSvg)('IconCrossInsideCircle', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,2A6,6,0,1,1,2,8,6,6,0,0,1,8,2M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.5,10.2L9.4,8.1,11.5,6a1,1,0,1,0-1.4-1.4L8,6.7,5.9,4.6A1,1,0,0,0,4.5,6L6.6,8.1,4.5,10.2a1,1,0,1,0,1.4,1.4L8,9.5l2.1,2.1a1,1,0,1,0,1.4-1.4Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconCrossInsideCircle = IconCrossInsideCircle;
var IconCross = (0, _createSvg.createSvg)('IconCross', new _interfaces.SVGIconWithSizes((_ref14 = {}, (0, _defineProperty2.default)(_ref14, _interfaces.IconSize.ExtraSmall, {
  paths: ['M9.41,8l3.3-3.29a1,1,0,1,0-1.42-1.42L8,6.59,4.71,3.29A1,1,0,0,0,3.29,4.71L6.59,8l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L8,9.41l3.29,3.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref14, _interfaces.IconSize.Small, {
  paths: ['M11.41425,10.00025 L16.70725,4.70725 C17.09825,4.31625 17.09825,3.68425 16.70725,3.29325 C16.31625,2.90225 15.68425,2.90225 15.29325,3.29325 L10.00025,8.58625 L4.70725,3.29325 C4.31625,2.90225 3.68425,2.90225 3.29325,3.29325 C2.90225,3.68425 2.90225,4.31625 3.29325,4.70725 L8.58625,10.00025 L3.29325,15.29325 C2.90225,15.68425 2.90225,16.31625 3.29325,16.70725 C3.48825,16.90225 3.74425,17.00025 4.00025,17.00025 C4.25625,17.00025 4.51225,16.90225 4.70725,16.70725 L10.00025,11.41425 L15.29325,16.70725 C15.48825,16.90225 15.74425,17.00025 16.00025,17.00025 C16.25625,17.00025 16.51225,16.90225 16.70725,16.70725 C17.09825,16.31625 17.09825,15.68425 16.70725,15.29325 L11.41425,10.00025 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref14)));
exports.IconCross = IconCross;
var IconDocument = (0, _createSvg.createSvg)('IconDocument', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10,9 L6,9 C5.447,9 5,8.553 5,8 C5,7.447 5.447,7 6,7 L10,7 C10.553,7 11,7.447 11,8 C11,8.553 10.553,9 10,9 M10,13 L6,13 C5.447,13 5,12.553 5,12 C5,11.447 5.447,11 6,11 L10,11 C10.553,11 11,11.447 11,12 C11,12.553 10.553,13 10,13 M6,3 L8,3 C8.553,3 9,3.447 9,4 C9,4.553 8.553,5 8,5 L6,5 C5.447,5 5,4.553 5,4 C5,3.447 5.447,3 6,3 M13.707,3.293 L10.707,0.293 C10.52,0.105 10.266,0 10,0 L3,0 C2.447,0 2,0.447 2,1 L2,15 C2,15.553 2.447,16 3,16 L13,16 C13.553,16 14,15.553 14,15 L14,4 C14,3.734 13.895,3.48 13.707,3.293'],
  params: {
    width: '16',
    height: '16'
  },
  height: 16,
  width: 16
})));
exports.IconDocument = IconDocument;
var IconDoubleChevronLeft = (0, _createSvg.createSvg)('IconDoubleChevronLeft', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.7,13a1,1,0,0,1-.71-.29l-4-4a1,1,0,0,1,0-1.42l4-4a1,1,0,1,1,1.42,1.42L4.91,8l3.3,3.29a1,1,0,0,1,0,1.42A1,1,0,0,1,7.5,13M12.5,13a1,1,0,0,1-.71-.29l-4-4a1,1,0,0,1,0-1.42l4-4a1,1,0,1,1,1.42,1.42L9.91,8l3.3,3.29a1,1,0,0,1,0,1.42A1,1,0,0,1,12.5,13Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconDoubleChevronLeft = IconDoubleChevronLeft;
var IconDoubleChevronRight = (0, _createSvg.createSvg)('IconDoubleChevronRight', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3.5,13a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L6.09,8,2.79,4.71A1,1,0,0,1,4.21,3.29l4,4a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,3.5,13M8.5,13a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L11.09,8,7.79,4.71A1,1,0,0,1,9.21,3.29l4,4a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,8.5,13Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconDoubleChevronRight = IconDoubleChevronRight;
var IconExternalLink = (0, _createSvg.createSvg)('IconExternalLink', new _interfaces.SVGIconWithSizes((_ref18 = {}, (0, _defineProperty2.default)(_ref18, _interfaces.IconSize.ExtraSmall, {
  paths: ['M13,8c-0.6,0-1,0.4-1,1v5H2V4h5c0.6,0,1-0.4,1-1S7.6,2,7,2H1C0.4,2,0,2.4,0,3v12c0,0.6,0.4,1,1,1h12 c0.6,0,1-0.4,1-1V9C14,8.4,13.6,8,13,8z', 'M15.9,0.6c-0.1-0.2-0.3-0.4-0.5-0.5C15.3,0,15.1,0,15,0h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.6L7.3,7.3 c-0.4,0.4-0.4,1,0,1.4C7.5,8.9,7.7,9,8,9s0.5-0.1,0.7-0.3L14,3.4V5c0,0.6,0.4,1,1,1s1-0.4,1-1V1C16,0.9,16,0.7,15.9,0.6z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref18, _interfaces.IconSize.Small, {
  paths: ['M16,10a1,1,0,0,0-1,1v6H3V5H9.42a1,1,0,0,0,0-2H2A1,1,0,0,0,1,4V18a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V11A1,1,0,0,0,16,10Z', 'M18.92,1.62a1,1,0,0,0-.54-.54A1,1,0,0,0,18,1H13a1,1,0,0,0,0,2h2.59L9.29,9.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L17,4.41V7a1,1,0,0,0,2,0V2A1,1,0,0,0,18.92,1.62Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _ref18)));
exports.IconExternalLink = IconExternalLink;
var IconHeartFill = (0, _createSvg.createSvg)('IconHeartFill', new _interfaces.SVGIconWithSizes((_ref19 = {}, (0, _defineProperty2.default)(_ref19, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,15l-1-.94C3.38,10.76,1,8.57,1,5.9A3.83,3.83,0,0,1,4.85,2,4.15,4.15,0,0,1,8,3.48,4.15,4.15,0,0,1,11.15,2,3.83,3.83,0,0,1,15,5.9c0,2.67-2.38,4.86-6,8.17Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref19, _interfaces.IconSize.Small, {
  paths: ['M10,18.86,8.69,17.65C4.06,13.36,1,10.53,1,7.05A5,5,0,0,1,6,2,5.34,5.34,0,0,1,10,3.92,5.32,5.32,0,0,1,14.05,2,5,5,0,0,1,19,7.05c0,3.48-3.06,6.31-7.7,10.61Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref19, _interfaces.IconSize.Medium, {
  paths: ['M12,23l-1.6-1.51C4.74,16.12,1,12.6,1,8.28A6.1,6.1,0,0,1,7,2a6.51,6.51,0,0,1,5,2.39A6.47,6.47,0,0,1,16.93,2a6.1,6.1,0,0,1,6,6.28c0,4.32-3.73,7.84-9.39,13.18Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref19, _interfaces.IconSize.Large, {
  paths: ['M16,30l-2-2C6.76,20.86,2,16.16,2,10.39,2,5.69,5.39,2,9.7,2A8.13,8.13,0,0,1,16,5.19,8.13,8.13,0,0,1,22.3,2C26.61,2,30,5.69,30,10.39,30,16.16,25.24,20.86,18,28Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref19)));
exports.IconHeartFill = IconHeartFill;
var IconHeart = (0, _createSvg.createSvg)('IconHeart', new _interfaces.SVGIconWithSizes((_ref20 = {}, (0, _defineProperty2.default)(_ref20, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,14.67a1,1,0,0,1-.68-.27l-.87-.82C3.16,10.52,1,8.5,1,5.73a4.3,4.3,0,0,1,4.3-4.4A4.56,4.56,0,0,1,8,2.25a4.56,4.56,0,0,1,2.7-.92A4.3,4.3,0,0,1,15,5.73c0,2.76-2.16,4.78-5.42,7.84l-.9.83A1,1,0,0,1,8,14.67ZM5.3,3.33A2.33,2.33,0,0,0,3,5.73c0,1.9,1.91,3.68,4.8,6.38l.2.19.19-.18C11.09,9.41,13,7.62,13,5.73a2.33,2.33,0,0,0-2.3-2.4,2.54,2.54,0,0,0-1.93.93,1,1,0,0,1-1.54,0A2.54,2.54,0,0,0,5.3,3.33Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref20, _interfaces.IconSize.Small, {
  paths: ['M10,19.06a1,1,0,0,1-.68-.27L8.16,17.7C3.84,13.67,1,11,1,7.47A5.41,5.41,0,0,1,6.4,1.94,5.68,5.68,0,0,1,10,3.26a5.68,5.68,0,0,1,3.6-1.32A5.41,5.41,0,0,1,19,7.47c0,3.54-2.83,6.19-7.13,10.21l-1.19,1.11A1,1,0,0,1,10,19.06ZM6.4,3.94A3.43,3.43,0,0,0,3,7.47c0,2.68,2.59,5.1,6.51,8.76l.49.46.48-.45C14.42,12.56,17,10.14,17,7.47a3.43,3.43,0,0,0-3.4-3.53A3.72,3.72,0,0,0,10.77,5.3a1,1,0,0,1-1.54,0A3.72,3.72,0,0,0,6.4,3.94Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref20, _interfaces.IconSize.Medium, {
  paths: ['M12,23a1,1,0,0,1-.69-.27L9.86,21.36C4.52,16.34,1,13,1,8.69A6.52,6.52,0,0,1,7.5,2,6.86,6.86,0,0,1,12,3.73,6.86,6.86,0,0,1,16.5,2,6.52,6.52,0,0,1,23,8.69c0,4.34-3.51,7.64-8.82,12.64l-1.5,1.4A1,1,0,0,1,12,23ZM7.5,4A4.55,4.55,0,0,0,3,8.69c0,3.48,3.27,6.55,8.22,11.2l.78.74.77-.72c5-4.68,8.23-7.74,8.23-11.22A4.55,4.55,0,0,0,16.5,4a4.89,4.89,0,0,0-3.73,1.8,1,1,0,0,1-1.54,0A4.89,4.89,0,0,0,7.5,4Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref20, _interfaces.IconSize.Large, {
  paths: ['M16,30a1,1,0,0,1-.7-.29l-1.89-1.87C6.53,21,2,16.56,2,10.79,2,5.86,5.58,2,10.15,2A8.44,8.44,0,0,1,16,4.46,8.44,8.44,0,0,1,21.85,2C26.42,2,30,5.86,30,10.79c0,5.76-4.52,10.24-11.36,17L16.7,29.71A1,1,0,0,1,16,30ZM10.15,4C6.7,4,4,7,4,10.79,4,15.73,8.3,20,14.8,26.4L16,27.59l1.18-1.16C23.72,20,28,15.72,28,10.79,28,7,25.3,4,21.85,4a6.51,6.51,0,0,0-5.06,2.58,1,1,0,0,1-1.58,0A6.51,6.51,0,0,0,10.15,4Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref20)));
exports.IconHeart = IconHeart;
var IconInformationFill = (0, _createSvg.createSvg)('IconInformationFill', new _interfaces.SVGIconWithSizes((_ref21 = {}, (0, _defineProperty2.default)(_ref21, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,13a1,1,0,0,1-2,0V7A1,1,0,0,1,9,7ZM8,4H8A1,1,0,0,1,7,3H7A1,1,0,0,1,8,2H8A1,1,0,0,1,9,3H9A1,1,0,0,1,8,4Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref21, _interfaces.IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm1,16.25a1,1,0,0,1-2,0V8.75a1,1,0,0,1,2,0ZM10.92,4.13a1.15,1.15,0,0,1-.21.33,1,1,0,0,1-.71.29.84.84,0,0,1-.38-.08,1.15,1.15,0,0,1-.33-.21,1.15,1.15,0,0,1-.21-.33A1,1,0,0,1,9,3.75,1.05,1.05,0,0,1,9.29,3a1.15,1.15,0,0,1,.33-.21A1,1,0,0,1,10.71,3a1,1,0,0,1,.21.33.94.94,0,0,1,0,.76Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref21, _interfaces.IconSize.Medium, {
  paths: ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm1,19.5a1,1,0,0,1-2,0v-9a1,1,0,0,1,2,0ZM12.92,5.88a1,1,0,0,1-.22.33,1,1,0,0,1-.7.29,1,1,0,0,1-.39-.08A1,1,0,0,1,11,5.5a1,1,0,0,1,.29-.71l.15-.12a1.08,1.08,0,0,1,.36-.15,1,1,0,0,1,.58.06,1,1,0,0,1,.32.21,1,1,0,0,1,.3.71A1,1,0,0,1,12.92,5.88Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref21, _interfaces.IconSize.Large, {
  paths: ['M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm1,25a1,1,0,0,1-2,0V13a1,1,0,0,1,2,0ZM16.92,7.38a1.15,1.15,0,0,1-.21.33,1,1,0,0,1-1.63-1.09,1,1,0,0,1,.21-.33A1,1,0,0,1,17,7,1,1,0,0,1,16.92,7.38Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref21)));
exports.IconInformationFill = IconInformationFill;
var IconInformation = (0, _createSvg.createSvg)('IconInformation', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,2A6,6,0,1,1,2,8,6,6,0,0,1,8,2M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,12a1,1,0,1,1-2,0V7A1,1,0,1,1,9,7ZM8.7,4.7A1,1,0,0,1,7,4a.8.8,0,0,1,.1-.4l.2-.3a1,1,0,0,1,1.4,0l.2.3a1,1,0,0,1-.2,1.1Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconInformation = IconInformation;
var IconMinus = (0, _createSvg.createSvg)('IconMinus', new _interfaces.SVGIconWithSizes((_ref23 = {}, (0, _defineProperty2.default)(_ref23, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.66,9H3.34a1,1,0,0,1,0-2h9.32a1,1,0,0,1,0,2Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref23, _interfaces.IconSize.Small, {
  paths: ['M4.00000017,9 L16,9 C16.5522847,9 17,9.44771525 17,10 C17,10.5522847 16.5522847,11 16,11 L4,11 C3.44771525,11 3,10.5522847 3,10 C3,9.44771525 3.44771525,9 4,9 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref23)));
exports.IconMinus = IconMinus;
var IconNotificationFill = (0, _createSvg.createSvg)('IconNotificationFill', new _interfaces.SVGIconWithSizes((_ref24 = {}, (0, _defineProperty2.default)(_ref24, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15,10.29s-1-.55-1-1.38V5.82a6,6,0,0,0-12,0V8.91c0,.83-1,1.38-1,1.38a1,1,0,0,0-.53.88v1.31a1,1,0,0,0,1,1H5.16a3,3,0,0,0,5.74,0h3.63a1,1,0,0,0,1-1V11.17A1,1,0,0,0,15,10.29Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref24, _interfaces.IconSize.Small, {
  paths: ['M18.4,13.56S17,12.82,17,11.72V8a7.09,7.09,0,0,0-6-6.91V1A1,1,0,0,0,9,1v.08A7.08,7.08,0,0,0,3,8v3.73c0,1.12-1.43,1.83-1.44,1.84a1,1,0,0,0-.57.89v1.49a1,1,0,0,0,1,1H6.16a4,4,0,0,0,7.69,0H18a1,1,0,0,0,1-1V14.45A1,1,0,0,0,18.4,13.56Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref24, _interfaces.IconSize.Medium, {
  paths: ['M22.38,16.53S20,15.51,20,14V10.28a8,8,0,0,0-7-8.21V1a1,1,0,0,0-2,0v1a8,8,0,0,0-7.07,8.23V14c0,1.52-2.36,2.53-2.38,2.54a1,1,0,0,0-.62.93V19a1,1,0,0,0,1,1H7.47a4.72,4.72,0,0,0,9.33,0H22a1,1,0,0,0,1-1V17.46A1,1,0,0,0,22.38,16.53ZM12.13,22A2.81,2.81,0,0,1,9.44,20h5.39A2.82,2.82,0,0,1,12.13,22Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref24, _interfaces.IconSize.Large, {
  paths: ['M29.46,22.41S27,21.07,27,18.76V12.58A10.93,10.93,0,0,0,17,2V1a1,1,0,0,0-2,0V2C9.45,2.49,4.9,7.13,4.9,12.58v6.18c0,2.29-2.46,3.63-2.48,3.65a1,1,0,0,0-.54.88v2.62a1,1,0,0,0,1,1h7.19a6,6,0,0,0,11.86,0H29a1,1,0,0,0,1-1V23.29A1,1,0,0,0,29.46,22.41ZM16,30a4,4,0,0,1-3.88-3h7.76A4,4,0,0,1,16,30Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref24)));
exports.IconNotificationFill = IconNotificationFill;
var IconNotification = (0, _createSvg.createSvg)('IconNotification', new _interfaces.SVGIconWithSizes((_ref25 = {}, (0, _defineProperty2.default)(_ref25, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15,10.29s-1-.55-1-1.38V5.82a6,6,0,0,0-12,0V8.91c0,.83-1,1.38-1,1.38a1,1,0,0,0-.53.88v1.31a1,1,0,0,0,1,1H5.16a3,3,0,0,0,5.74,0h3.63a1,1,0,0,0,1-1V11.17A1,1,0,0,0,15,10.29ZM2.74,11.49A3.51,3.51,0,0,0,4,8.91V5.82A4,4,0,0,1,8,2a4,4,0,0,1,4,3.82V8.91a3.51,3.51,0,0,0,1.24,2.58Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref25, _interfaces.IconSize.Small, {
  paths: ['M18.4,13.56S17,12.82,17,11.72V8a7.09,7.09,0,0,0-6-6.91V1A1,1,0,0,0,9,1v.08A7.08,7.08,0,0,0,3,8v3.73c0,1.12-1.43,1.83-1.44,1.84a1,1,0,0,0-.57.89v1.49a1,1,0,0,0,1,1H6.16a4,4,0,0,0,7.69,0H18a1,1,0,0,0,1-1V14.45A1,1,0,0,0,18.4,13.56ZM10,17.94a2,2,0,0,1-1.72-1h3.44A2,2,0,0,1,10,17.94Zm-6.87-3A4.06,4.06,0,0,0,5,11.72V8a5.12,5.12,0,0,1,5-5,5.13,5.13,0,0,1,5,5v3.73a4,4,0,0,0,1.89,3.22Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref25, _interfaces.IconSize.Medium, {
  paths: ['M22.38,16.53S20,15.51,20,14V10.28a8,8,0,0,0-7-8.21V1a1,1,0,0,0-2,0v1a8,8,0,0,0-7.07,8.23V14c0,1.52-2.36,2.53-2.38,2.54a1,1,0,0,0-.62.93V19a1,1,0,0,0,1,1H7.47a4.72,4.72,0,0,0,9.33,0H22a1,1,0,0,0,1-1V17.46A1,1,0,0,0,22.38,16.53ZM12.13,22a2.73,2.73,0,0,1-2.62-2h5.25A2.75,2.75,0,0,1,12.13,22Zm-.2-4H3.07c1.07-.61,2.86-1.94,2.86-4V10.28A6,6,0,0,1,12,4a5.94,5.94,0,0,1,6,6.28V14c0,2.07,1.79,3.4,2.86,4Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref25, _interfaces.IconSize.Large, {
  paths: ['M29.46,22.41S27,21.07,27,18.76V12.58A10.93,10.93,0,0,0,17,2V1a1,1,0,0,0-2,0V2C9.45,2.49,4.9,7.13,4.9,12.58v6.18c0,2.29-2.46,3.63-2.48,3.65a1,1,0,0,0-.54.88v2.62a1,1,0,0,0,1,1h7.19a6,6,0,0,0,11.86,0H29a1,1,0,0,0,1-1V23.29A1,1,0,0,0,29.46,22.41ZM16,30a4,4,0,0,1-3.88-3h7.76A4,4,0,0,1,16,30Zm12-5H3.88V23.85a6.4,6.4,0,0,0,3-5.09V12.58C6.9,7.9,11.07,4,16,4a8.93,8.93,0,0,1,9,8.63v6.18a6.4,6.4,0,0,0,3,5.09Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref25)));
exports.IconNotification = IconNotification;
var IconPadlockFill = (0, _createSvg.createSvg)('IconPadlockFill', new _interfaces.SVGIconWithSizes((_ref26 = {}, (0, _defineProperty2.default)(_ref26, _interfaces.IconSize.ExtraSmall, {
  paths: ['M13,5H11.5V3.5a3.5,3.5,0,0,0-7,0V5H3A1,1,0,0,0,2,6v9a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V6A1,1,0,0,0,13,5ZM9,11.5a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0ZM9.5,5h-3V3.5a1.5,1.5,0,0,1,3,0Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref26, _interfaces.IconSize.Small, {
  paths: ['M17,6H14V4A4,4,0,0,0,6,4V6H3A1,1,0,0,0,2,7V19a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V7A1,1,0,0,0,17,6Zm-6,9a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0Zm1-9H8V4a2,2,0,0,1,4,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _ref26)));
exports.IconPadlockFill = IconPadlockFill;
var IconPaymentFill = (0, _createSvg.createSvg)('IconPaymentFill', new _interfaces.SVGIconWithSizes((_ref27 = {}, (0, _defineProperty2.default)(_ref27, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15,2H1A1,1,0,0,0,0,3V13a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V3A1,1,0,0,0,15,2ZM2,4H14V6H2Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref27, _interfaces.IconSize.Small, {
  paths: ['M19,3H1A1,1,0,0,0,0,4V16a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V4A1,1,0,0,0,19,3ZM16,13H12a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Zm2-6H2V5H18Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref27, _interfaces.IconSize.Medium, {
  paths: ['M23,3H1A1,1,0,0,0,0,4V20a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V4A1,1,0,0,0,23,3ZM19,17H15a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2ZM22,5V8H2V5Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref27, _interfaces.IconSize.Large, {
  paths: ['M31,5H1A1,1,0,0,0,0,6V26a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V6A1,1,0,0,0,31,5ZM28,22a1,1,0,0,1-1,1H23a1,1,0,0,1,0-2h4A1,1,0,0,1,28,22ZM30,7v4H2V7Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref27)));
exports.IconPaymentFill = IconPaymentFill;
var IconPayment = (0, _createSvg.createSvg)('IconPayment', new _interfaces.SVGIconWithSizes((_ref28 = {}, (0, _defineProperty2.default)(_ref28, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15,14H1a1,1,0,0,1-1-1V3A1,1,0,0,1,1,2H15a1,1,0,0,1,1,1V13A1,1,0,0,1,15,14ZM2,12H14V4H2Z', 'M2 6H14V8H2z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref28, _interfaces.IconSize.Small, {
  paths: ['M19,17H1a1,1,0,0,1-1-1V4A1,1,0,0,1,1,3H19a1,1,0,0,1,1,1V16A1,1,0,0,1,19,17ZM2,15H18V5H2Z', 'M16 13H12a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zM19 9H1A1 1 0 0 1 1 7H19a1 1 0 0 1 0 2z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref28, _interfaces.IconSize.Medium, {
  paths: ['M23,21H1a1,1,0,0,1-1-1V4A1,1,0,0,1,1,3H23a1,1,0,0,1,1,1V20A1,1,0,0,1,23,21ZM2,19H22V5H2Z', 'M23 10H1A1 1 0 0 1 1 8H23a1 1 0 0 1 0 2zM19 17H15a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref28, _interfaces.IconSize.Large, {
  paths: ['M31,27H1a1,1,0,0,1-1-1V6A1,1,0,0,1,1,5H31a1,1,0,0,1,1,1V26A1,1,0,0,1,31,27ZM2,25H30V7H2Z', 'M29.93 13H2.07a1 1 0 0 1 0-2H29.93a1 1 0 0 1 0 2zM27 23H23a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref28)));
exports.IconPayment = IconPayment;
var IconPlusCircle = (0, _createSvg.createSvg)('IconPlusCircle', new _interfaces.SVGIconWithSizes((_ref29 = {}, (0, _defineProperty2.default)(_ref29, _interfaces.IconSize.ExtraSmall, {
  paths: ['M11.48,7H9V4.49a1,1,0,0,0-2,0V7H4.49a1,1,0,0,0,0,2H7v2.49a1,1,0,0,0,2,0V9h2.49a1,1,0,0,0,0-2Z', 'M8,.11A7.88,7.88,0,1,0,15.86,8,7.88,7.88,0,0,0,8,.11Zm0,14A6.1,6.1,0,1,1,14.08,8,6.1,6.1,0,0,1,8,14.08Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref29, _interfaces.IconSize.Small, {
  paths: ['M14.5,9H11V5.5a1,1,0,0,0-2,0V9H5.5a1,1,0,0,0,0,2H9v3.5a1,1,0,0,0,2,0V11h3.5a1,1,0,0,0,0-2Z', 'M10,.11A9.89,9.89,0,1,0,19.89,10,9.91,9.91,0,0,0,10,.11Zm0,18A8.11,8.11,0,1,1,18.11,10,8.12,8.12,0,0,1,10,18.11Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref29, _interfaces.IconSize.Medium, {
  paths: ['M17.46,11H13V6.49a1,1,0,1,0-2,0V11H6.49a1,1,0,1,0,0,2H11v4.48a1,1,0,0,0,2,0V13h4.48a1,1,0,0,0,0-2Z', 'M12,.11A11.87,11.87,0,1,0,23.84,12,11.88,11.88,0,0,0,12,.11Zm0,22A10.09,10.09,0,1,1,22.06,12,10.09,10.09,0,0,1,12,22.06Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref29, _interfaces.IconSize.Large, {
  paths: ['M16,1.1A14.9,14.9,0,1,0,30.89,16,14.91,14.91,0,0,0,16,1.1Zm0,28A13.12,13.12,0,1,1,29.11,16,13.13,13.13,0,0,1,16,29.11Z', 'M23,15H17V9a1,1,0,1,0-2,0v6H9a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V17h6a1,1,0,0,0,0-2Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref29)));
exports.IconPlusCircle = IconPlusCircle;
var IconPlus = (0, _createSvg.createSvg)('IconPlus', new _interfaces.SVGIconWithSizes((_ref30 = {}, (0, _defineProperty2.default)(_ref30, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.66,7H9V3.34a1,1,0,0,0-2,0V7H3.34a1,1,0,0,0,0,2H7v3.66a1,1,0,0,0,2,0V9h3.66a1,1,0,0,0,0-2Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref30, _interfaces.IconSize.Small, {
  paths: ['M16,9 L11,9 L11,4 C11,3.447 10.553,3 10,3 C9.447,3 9,3.447 9,4 L9,9 L4,9 C3.447,9 3,9.447 3,10 C3,10.553 3.447,11 4,11 L9,11 L9,16 C9,16.553 9.447,17 10,17 C10.553,17 11,16.553 11,16 L11,11 L16,11 C16.553,11 17,10.553 17,10 C17,9.447 16.553,9 16,9'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref30)));
exports.IconPlus = IconPlus;
var IconQuestionCircle = (0, _createSvg.createSvg)('IconQuestionCircle', new _interfaces.SVGIconWithSizes((_ref31 = {}, (0, _defineProperty2.default)(_ref31, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0 C12.4115556,0 16,3.58844444 16,8 C16,12.4115556 12.4115556,16 8,16 C3.58844444,16 0,12.4115556 0,8 C0,3.58844444 3.58844444,0 8,0 Z M8,1.6 C4.47177143,1.6 1.6,4.47177143 1.6,8 C1.6,11.5282286 4.47177143,14.4 8,14.4 C11.5282286,14.4 14.4,11.5282286 14.4,8 C14.4,4.47177143 11.5282286,1.6 8,1.6 Z M7.8648,10.1924982 C8.1848,10.1972982 8.4432,10.3012982 8.6408,10.5028982 C8.8376,10.7060982 8.9336,10.9684982 8.9296,11.2876982 C8.9248,11.6076982 8.8208,11.8668982 8.6176,12.0636982 C8.4152,12.2612982 8.1536,12.3572982 7.8336,12.3524982 C7.5136,12.3476982 7.2544,12.2436982 7.0576,12.0404982 C6.8608,11.8380982 6.7648,11.5764982 6.7688,11.2564982 C6.7736,10.9364982 6.8776,10.6780982 7.0808,10.4804982 C7.2832,10.2836982 7.5448,10.1876982 7.8648,10.1924982 Z M8.236,3.68049825 C8.996,3.69169825 9.5864,3.88849825 10.0096,4.27009825 C10.432,4.65329825 10.6376,5.17169825 10.6288,5.82849825 C10.62,6.37969825 10.4536,6.85809825 10.1272,7.26129825 C9.8016,7.66369825 9.276,8.04849825 8.5512,8.41329825 L8.536,9.43409825 L7.168,9.41409825 L7.048,7.79169825 L7.6768,7.46529825 C8.12,7.23969825 8.4376,7.01489825 8.6288,6.78929825 C8.82,6.56449825 8.9176,6.29569825 8.9224,5.98289825 C8.9264,5.69569825 8.84,5.47169825 8.6624,5.31329825 C8.484,5.15489825 8.228,5.07249825 7.8912,5.06849825 C7.332,5.06049825 6.7008,5.21889825 6,5.54449825 L6.0192,4.21249825 C6.7128,3.84689825 7.4512,3.66929825 8.236,3.68049825 Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref31, _interfaces.IconSize.Small, {
  paths: ['M10,1 C14.963,1 19,5.037 19,10 C19,14.963 14.963,19 10,19 C5.037,19 1,14.963 1,10 C1,5.037 5.037,1 10,1 Z M10,17 C13.859,17 17,13.859 17,10 C17,6.141 13.859,3 10,3 C6.141,3 3,6.141 3,10 C3,13.859 6.141,17 10,17 Z M9.792,15.4406228 C9.392,15.4346228 9.068,15.3046228 8.822,15.0506228 C8.576,14.7976228 8.456,14.4706228 8.461,14.0706228 C8.467,13.6706228 8.597,13.3476228 8.851,13.1006228 C9.104,12.8546228 9.431,12.7346228 9.831,12.7406228 C10.231,12.7466228 10.554,12.8766228 10.801,13.1286228 C11.047,13.3826228 11.167,13.7106228 11.162,14.1096228 C11.156,14.5096228 11.026,14.8336228 10.772,15.0796228 C10.519,15.3266228 10.192,15.4466228 9.792,15.4406228 Z M11.153,7.47862281 C11.158,7.11962281 11.05,6.83962281 10.828,6.64162281 C10.605,6.44362281 10.285,6.34062281 9.864,6.33562281 C9.165,6.32562281 8.376,6.52362281 7.5,6.93062281 L7.524,5.26562281 C8.391,4.80862281 9.314,4.58662281 10.295,4.60062281 C11.245,4.61462281 11.983,4.86062281 12.512,5.33762281 C13.04,5.81662281 13.297,6.46462281 13.286,7.28562281 C13.275,7.97462281 13.067,8.57262281 12.659,9.07662281 C12.252,9.57962281 11.595,10.0606228 10.689,10.5166228 L10.67,11.7926228 L8.96,11.7676228 L8.81,9.73962281 L9.596,9.33162281 C10.15,9.04962281 10.547,8.76862281 10.786,8.48662281 C11.025,8.20562281 11.147,7.86962281 11.153,7.47862281 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref31)));
exports.IconQuestionCircle = IconQuestionCircle;
var IconSearch = (0, _createSvg.createSvg)('IconSearch', new _interfaces.SVGIconWithSizes((_ref32 = {}, (0, _defineProperty2.default)(_ref32, _interfaces.IconSize.ExtraSmall, {
  paths: ['M14.77,13.67l-4-4a5.47,5.47,0,1,0-1.1,1.1l4,4a.77.77,0,0,0,1.1,0A.77.77,0,0,0,14.77,13.67ZM2.56,6.44a3.89,3.89,0,1,1,3.88,3.89A3.88,3.88,0,0,1,2.56,6.44Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref32, _interfaces.IconSize.Small, {
  paths: ['M3,8 C3,5.243 5.243,3 8,3 C10.757,3 13,5.243 13,8 C13,10.757 10.757,13 8,13 C5.243,13 3,10.757 3,8 M18.707,17.293 L13.599,12.185 C14.475,11.016 15,9.569 15,8 C15,4.141 11.859,1 8,1 C4.141,1 1,4.141 1,8 C1,11.859 4.141,15 8,15 C9.569,15 11.016,14.475 12.185,13.599 L17.293,18.707 C17.488,18.902 17.744,19 18,19 C18.256,19 18.512,18.902 18.707,18.707 C19.098,18.316 19.098,17.684 18.707,17.293'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref32)));
exports.IconSearch = IconSearch;
var IconSortAscending = (0, _createSvg.createSvg)('IconSortAscending', new _interfaces.SVGIconWithSizes((_ref33 = {}, (0, _defineProperty2.default)(_ref33, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.7 3.3l-3-3C4.6.2 4.5.1 4.4.1 4.3 0 4.1 0 4 0S3.7 0 3.6.1C3.5.1 3.4.2 3.3.3l-3 3c-.4.4-.4 1 0 1.4s1 .4 1.4 0L3 3.4V15c0 .6.4 1 1 1s1-.4 1-1V3.4l1.3 1.3c.4.4 1 .4 1.4 0S8.1 3.7 7.7 3.3zM15 12H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1S15.6 12 15 12zM9 8h2c.6 0 1-.4 1-1s-.4-1-1-1H9C8.4 6 8 6.4 8 7S8.4 8 9 8zM8 10c0 .6.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H9C8.4 9 8 9.4 8 10z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref33, _interfaces.IconSize.Small, {
  paths: ['M9.8 4.3l-3-3C6.7 1.2 6.6 1.1 6.5 1.1 6.3 1 6.2 1 6.1 1S5.8 1 5.7 1.1C5.6 1.1 5.5 1.2 5.4 1.3l-3 3C2 4.7 2 5.3 2.4 5.7s1 .4 1.4 0l1.3-1.3V18c0 .6.4 1 1 1s1-.4 1-1V4.4l1.3 1.3c.4.4 1 .4 1.4 0S10.2 4.7 9.8 4.3zM17.1 16h-6c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1S17.6 16 17.1 16zM11.1 10h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1S10.5 10 11.1 10zM10.1 13c0 .6.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1h-4C10.5 12 10.1 12.4 10.1 13z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _ref33)));
exports.IconSortAscending = IconSortAscending;
var IconSortDescending = (0, _createSvg.createSvg)('IconSortDescending', new _interfaces.SVGIconWithSizes((_ref34 = {}, (0, _defineProperty2.default)(_ref34, _interfaces.IconSize.ExtraSmall, {
  paths: ['M6.3 11.3L5 12.6V1c0-.6-.4-1-1-1S3 .4 3 1v11.6l-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.1.1.2.2.3.2C3.7 16 3.9 16 4 16s.3 0 .4-.1c.1-.1.2-.1.3-.2l3-3c.4-.4.4-1 0-1.4S6.7 10.9 6.3 11.3zM15 2H9C8.4 2 8 2.4 8 3s.4 1 1 1h6c.6 0 1-.4 1-1S15.6 2 15 2zM11 8H9C8.4 8 8 8.4 8 9s.4 1 1 1h2c.6 0 1-.4 1-1S11.6 8 11 8zM13 5H9C8.4 5 8 5.4 8 6s.4 1 1 1h4c.6 0 1-.4 1-1S13.6 5 13 5z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref34, _interfaces.IconSize.Small, {
  paths: ['M8.4 14.3l-1.3 1.3V2c0-.6-.4-1-1-1s-1 .4-1 1v13.6l-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.1.1.2.2.3.2C5.8 18.9 5.9 19 6.1 19s.3 0 .4-.1c.1-.1.2-.1.3-.2l3-3c.4-.4.4-1 0-1.4S8.8 13.9 8.4 14.3zM17.1 2h-6c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1S17.6 2 17.1 2zM13.1 10h-2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1S13.6 10 13.1 10zM15.1 6h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1S15.6 6 15.1 6z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _ref34)));
exports.IconSortDescending = IconSortDescending;
var IconSort = (0, _createSvg.createSvg)('IconSort', new _interfaces.SVGIconWithSizes((_ref35 = {}, (0, _defineProperty2.default)(_ref35, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5.3895,0.07575 C5.5125,0.12675 5.6235,0.19975 5.7155,0.29275 L8.72125,3.286 C9.11225,3.677 9.11225,4.309 8.72125,4.7 C8.52625,4.895 8.27025,4.993 8.01425,4.993 C7.75825,4.993 7.50225,4.895 7.30725,4.7 L6.0075,3.41275 L6.0075,14.99875 C6.0075,15.55175 5.5605,15.99875 5.0075,15.99875 C4.4545,15.99875 4.0075,15.55175 4.0075,14.99875 L4.0075,3.41275 L2.70725,4.7 C2.24727075,5.091 1.68425,5.091 1.29325,4.7 C0.90225,4.309 0.90225,3.677 1.29325,3.286 L4.2995,0.29275 C4.3915,0.19975 4.5025,0.12675 4.6255,0.07575 C4.8695,-0.02525 5.1455,-0.02525 5.3895,0.07575 Z M11.007,2.10498285e-13 C11.56,2.10498285e-13 12.007,0.447 12.007,1 L12.007,12.586 L13.30725,11.29875 C13.7672292,10.90775 14.33025,10.90775 14.72125,11.29875 C15.11225,11.68975 15.11225,12.32175 14.72125,12.71275 L11.715,15.706 C11.623,15.799 11.512,15.872 11.389,15.923 C11.145,16.024 10.869,16.024 10.625,15.923 C10.502,15.872 10.391,15.799 10.299,15.706 L7.29325,12.71275 C6.90225,12.32175 6.90225,11.68975 7.29325,11.29875 C7.48825,11.10375 7.74425,11.00575 8.00025,11.00575 C8.25625,11.00575 8.51225,11.10375 8.70725,11.29875 L10.007,12.586 L10.007,1 C10.007,0.447 10.454,2.10498285e-13 11.007,2.10498285e-13 Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg',
    id: 'a'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref35, _interfaces.IconSize.Small, {
  paths: ['M9.707,4.293 C10.098,4.684 10.098,5.316 9.707,5.707 C9.512,5.902 9.256,6 9,6 C8.744,6 8.488,5.902 8.293,5.707 L7,4.414 L7,18 C7,18.553 6.553,19 6,19 C5.447,19 5,18.553 5,18 L5,4.414 L3.707,5.707 C3.316,6.098 2.684,6.098 2.293,5.707 C1.902,5.316 1.902,4.684 2.293,4.293 L5.292,1.294 C5.384,1.201 5.495,1.128 5.618,1.077 C5.862,0.976 6.138,0.976 6.382,1.077 C6.505,1.128 6.616,1.201 6.708,1.294 L9.707,4.293 Z M17.707,14.293 C18.098,14.684 18.098,15.316 17.707,15.707 L14.708,18.706 C14.616,18.799 14.505,18.872 14.382,18.923 C14.26,18.974 14.13,19 14,19 C13.87,19 13.74,18.974 13.618,18.923 C13.495,18.872 13.384,18.799 13.292,18.706 L10.293,15.707 C9.902,15.316 9.902,14.684 10.293,14.293 C10.684,13.902 11.316,13.902 11.707,14.293 L13,15.586 L13,2 C13,1.447 13.447,1 14,1 C14.553,1 15,1.447 15,2 L15,15.586 L16.293,14.293 C16.684,13.902 17.316,13.902 17.707,14.293 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _ref35)));
exports.IconSort = IconSort;
var IconStarFill = (0, _createSvg.createSvg)('IconStarFill', new _interfaces.SVGIconWithSizes((_ref36 = {}, (0, _defineProperty2.default)(_ref36, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3.44,16a1,1,0,0,1-.62-.22,1,1,0,0,1-.37-1l.85-4.28L.22,7.19A1,1,0,0,1,.83,5.52L5.11,5l2-3.92A1,1,0,0,1,8,.54a1,1,0,0,1,.9.55l2,3.91,4.29.52a1,1,0,0,1,.61,1.67L12.7,10.48l.85,4.15a1,1,0,0,1-1.38,1.12L8,13.91l-4.15,2A1,1,0,0,1,3.44,16ZM3,7.27,5.11,9.5a1,1,0,0,1,.25.87L4.8,13.21,7.57,11.9a1,1,0,0,1,.83,0l2.8,1.24-.57-2.75a1,1,0,0,1,.25-.88L13,7.27l-2.86-.35a1,1,0,0,1-.77-.54L8,3.74,6.65,6.38a1,1,0,0,1-.77.54Z', 'M3.47,16a1,1,0,0,1-.6-.2,1,1,0,0,1-.38-1l.84-4.51L.25,6.85a1,1,0,0,1-.19-1,1,1,0,0,1,.81-.64l4.25-.54,2-4.09A1,1,0,0,1,8,0a1,1,0,0,1,.89.57l2,4.08,4.25.54a1,1,0,0,1,.81.64,1,1,0,0,1-.19,1L12.66,10.3l.86,4.37a1,1,0,0,1-1.41,1.1L8,13.86l-4.09,2A1,1,0,0,1,3.47,16Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref36, _interfaces.IconSize.Small, {
  paths: ['M4.18,19.56a1,1,0,0,1-.62-.21,1,1,0,0,1-.37-1l1.11-5.6-4-4.31a1,1,0,0,1-.21-1,1,1,0,0,1,.82-.65L6.5,6.1,9.13,1A1,1,0,0,1,10,.44h0a1,1,0,0,1,.89.54L13.5,6.1l5.62.68a1,1,0,0,1,.82.65,1,1,0,0,1-.21,1l-4,4.3,1.11,5.44a1,1,0,0,1-1.38,1.11L10,16.91,4.6,19.47A1,1,0,0,1,4.18,19.56Zm-1.1-11,3,3.24a1,1,0,0,1,.25.88l-.82,4.16,4-1.9a1,1,0,0,1,.83,0l4.06,1.8-.83-4a1,1,0,0,1,.25-.89l3-3.24L12.73,8A1,1,0,0,1,12,7.48L10,3.64,8,7.49A1,1,0,0,1,7.26,8Z', 'M4.18,20a1,1,0,0,1-.61-.2,1,1,0,0,1-.38-1l1.12-5.94L.25,8.33a1,1,0,0,1-.19-1,1,1,0,0,1,.81-.64L6.48,6,9.12.56a1,1,0,0,1,1.8,0L13.51,6l5.62.71a1,1,0,0,1,.81.64,1,1,0,0,1-.19,1l-4.06,4.55,1.12,5.75a1,1,0,0,1-.36,1,1,1,0,0,1-1,.12L10,17.22,4.62,19.9A1,1,0,0,1,4.18,20Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref36, _interfaces.IconSize.Medium, {
  paths: ['M4.88,23.18A1,1,0,0,1,4.27,23a1,1,0,0,1-.37-1l1.37-7-5-5.35A1,1,0,0,1,.88,8l7-.84L11.13.79A1,1,0,0,1,12,.24a1,1,0,0,1,.89.55l3.22,6.37,7,.84a1,1,0,0,1,.61,1.68l-5,5.34,1.39,6.76a1,1,0,0,1-1.39,1.11l-6.71-3-6.7,3.16A.94.94,0,0,1,4.88,23.18Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref36, _interfaces.IconSize.Large, {
  paths: ['M6.94,31a1,1,0,0,1-.6-.2,1,1,0,0,1-.38-1l1.78-9.5L1.25,13a1,1,0,0,1-.19-1,1,1,0,0,1,.81-.64l9-1.15,4.23-8.66A1,1,0,0,1,16,1h0a1,1,0,0,1,.9.57l4.17,8.65,9,1.15a1,1,0,0,1,.81.64,1,1,0,0,1-.19,1l-6.5,7.28,1.8,9.22a1,1,0,0,1-1.4,1.1l-8.64-4L7.38,30.9A1,1,0,0,1,6.94,31Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref36)));
exports.IconStarFill = IconStarFill;
var IconStar = (0, _createSvg.createSvg)('IconStar', new _interfaces.SVGIconWithSizes((_ref37 = {}, (0, _defineProperty2.default)(_ref37, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3.44,16a1,1,0,0,1-.62-.22,1,1,0,0,1-.37-1l.85-4.28L.22,7.19A1,1,0,0,1,.83,5.52L5.11,5l2-3.92A1,1,0,0,1,8,.54a1,1,0,0,1,.9.55l2,3.91,4.29.52a1,1,0,0,1,.61,1.67L12.7,10.48l.85,4.15a1,1,0,0,1-1.38,1.12L8,13.91l-4.15,2A1,1,0,0,1,3.44,16ZM3,7.27,5.11,9.5a1,1,0,0,1,.25.87L4.8,13.21,7.57,11.9a1,1,0,0,1,.83,0l2.8,1.24-.57-2.75a1,1,0,0,1,.25-.88L13,7.27l-2.86-.35a1,1,0,0,1-.77-.54L8,3.74,6.65,6.38a1,1,0,0,1-.77.54Z', 'M3.47,16a1,1,0,0,1-.6-.2,1,1,0,0,1-.38-1l.84-4.51L.25,6.85a1,1,0,0,1-.19-1,1,1,0,0,1,.81-.64l4.25-.54,2-4.09A1,1,0,0,1,8,0a1,1,0,0,1,.89.57l2,4.08,4.25.54a1,1,0,0,1,.81.64,1,1,0,0,1-.19,1L12.66,10.3l.86,4.37a1,1,0,0,1-1.41,1.1L8,13.86l-4.09,2A1,1,0,0,1,3.47,16ZM3,6.93,5.15,9.34a1,1,0,0,1,.24.85l-.57,3,2.73-1.36a1.06,1.06,0,0,1,.87,0l2.76,1.29-.57-2.93a1,1,0,0,1,.23-.86L13,6.93l-2.9-.36A1,1,0,0,1,9.31,6L8,3.29,6.68,6a1,1,0,0,1-.78.56Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_ref37, _interfaces.IconSize.Small, {
  paths: ['M4.18,19.56a1,1,0,0,1-.62-.21,1,1,0,0,1-.37-1l1.11-5.6-4-4.31a1,1,0,0,1-.21-1,1,1,0,0,1,.82-.65L6.5,6.1,9.13,1A1,1,0,0,1,10,.44h0a1,1,0,0,1,.89.54L13.5,6.1l5.62.68a1,1,0,0,1,.82.65,1,1,0,0,1-.21,1l-4,4.3,1.11,5.44a1,1,0,0,1-1.38,1.11L10,16.91,4.6,19.47A1,1,0,0,1,4.18,19.56Zm-1.1-11,3,3.24a1,1,0,0,1,.25.88l-.82,4.16,4-1.9a1,1,0,0,1,.83,0l4.06,1.8-.83-4a1,1,0,0,1,.25-.89l3-3.24L12.73,8A1,1,0,0,1,12,7.48L10,3.64,8,7.49A1,1,0,0,1,7.26,8Z', 'M4.18,20a1,1,0,0,1-.61-.2,1,1,0,0,1-.38-1l1.12-5.94L.25,8.33a1,1,0,0,1-.19-1,1,1,0,0,1,.81-.64L6.48,6,9.12.56a1,1,0,0,1,1.8,0L13.51,6l5.62.71a1,1,0,0,1,.81.64,1,1,0,0,1-.19,1l-4.06,4.55,1.12,5.75a1,1,0,0,1-.36,1,1,1,0,0,1-1,.12L10,17.22,4.62,19.9A1,1,0,0,1,4.18,20ZM3,8.41l3.12,3.51a1,1,0,0,1,.23.85l-.83,4.44,4-2a1,1,0,0,1,.87,0l4.05,1.89-.84-4.32a1,1,0,0,1,.24-.85L17,8.41l-4.27-.54A1,1,0,0,1,12,7.32L10,3.29l-2,4a1,1,0,0,1-.77.55Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_ref37, _interfaces.IconSize.Medium, {
  paths: ['M4.88,23.18A1,1,0,0,1,4.27,23a1,1,0,0,1-.37-1l1.37-7-5-5.35A1,1,0,0,1,.88,8l7-.84L11.13.79A1,1,0,0,1,12,.24a1,1,0,0,1,.89.55l3.22,6.37,7,.84a1,1,0,0,1,.61,1.68l-5,5.34,1.39,6.76a1,1,0,0,1-1.39,1.11l-6.71-3-6.7,3.16A.94.94,0,0,1,4.88,23.18ZM3.08,9.75l4,4.28a1,1,0,0,1,.25.88L6.25,20.43l5.32-2.52a1,1,0,0,1,.83,0l5.36,2.38-1.1-5.36a1,1,0,0,1,.25-.89l4-4.28-5.56-.67a1,1,0,0,1-.77-.54L12,3.45,9.4,8.54a1,1,0,0,1-.77.54Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_ref37, _interfaces.IconSize.Large, {
  paths: ['M6.94,31a1,1,0,0,1-.6-.2,1,1,0,0,1-.38-1l1.78-9.5L1.25,13a1,1,0,0,1-.19-1,1,1,0,0,1,.81-.64l9-1.15,4.23-8.66A1,1,0,0,1,16,1h0a1,1,0,0,1,.9.57l4.17,8.65,9,1.15a1,1,0,0,1,.81.64,1,1,0,0,1-.19,1l-6.5,7.28,1.8,9.22a1,1,0,0,1-1.4,1.1l-8.64-4L7.38,30.9A1,1,0,0,1,6.94,31ZM4,13.12l5.55,6.23a1,1,0,0,1,.24.85l-1.51,8,7.26-3.61a1,1,0,0,1,.87,0L23.71,28l-1.52-7.78a1,1,0,0,1,.24-.86L28,13.12l-7.68-1a1,1,0,0,1-.78-.56L16,4.29l-3.56,7.3a1,1,0,0,1-.78.55Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _ref37)));
exports.IconStar = IconStar;
var IconTick = (0, _createSvg.createSvg)('IconTick', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14ZM6.2,11.3a1,1,0,0,0,1.4-.1l4.4-5.2A.9.9,0,0,0,12,4.8a.9.9,0,0,0-1.3.1L6.9,9.5l-2-1.9a.9.9,0,0,0-1.3,0,.9.9,0,0,0,0,1.2Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));
exports.IconTick = IconTick;
var IconAnchorLink = (0, _createSvg.createSvg)('IconAnchorLink', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M17.83,2.17a4.1,4.1,0,0,0-5.66,0L10.05,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.41,0l2.13-2.12a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82L12.13,10.7a2,2,0,0,1-2.65.16,1,1,0,1,0-1.24,1.57,4,4,0,0,0,5.3-.32l4.29-4.28a4,4,0,0,0,0-5.66Z', 'M8.54,14.29,6.41,16.41a2,2,0,0,1-2.82,0,2,2,0,0,1,0-2.82L7.87,9.3a2,2,0,0,1,2.65-.16,1,1,0,1,0,1.24-1.57,4,4,0,0,0-5.3.32L2.17,12.17a4,4,0,0,0,5.66,5.66L10,15.71a1,1,0,0,0,0-1.42A1,1,0,0,0,8.54,14.29Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconAnchorLink = IconAnchorLink;
var IconArrowLeft = (0, _createSvg.createSvg)('IconArrowLeft', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M18.99875,9.00025 L3.41275,9.00025 L7.70575,4.70725 C8.09675,4.31625 8.09675,3.68425 7.70575,3.29325 C7.31475,2.90225 6.68275,2.90225 6.29175,3.29325 L0.29275,9.29225 C0.19975,9.38425 0.12675,9.49525 0.07575,9.61825 C-0.02525,9.86225 -0.02525,10.13825 0.07575,10.38225 C0.12675,10.50525 0.19975,10.61625 0.29275,10.70825 L6.29175,16.70725 C6.48675,16.90225 6.74275,17.00025 6.99875,17.00025 C7.25475,17.00025 7.51075,16.90225 7.70575,16.70725 C8.09675,16.31625 8.09675,15.68425 7.70575,15.29325 L3.41275,11.00025 L18.99875,11.00025 C19.55175,11.00025 19.99875,10.55325 19.99875,10.00025 C19.99875,9.44725 19.55175,9.00025 18.99875,9.00025'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconArrowLeft = IconArrowLeft;
var IconArrowRight = (0, _createSvg.createSvg)('IconArrowRight', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M19.92,9.62a1,1,0,0,0-.21-.33l-6-6a1,1,0,0,0-1.42,1.42L16.59,9H1a1,1,0,0,0,0,2H16.59l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l6-6a1,1,0,0,0,.21-.33A1,1,0,0,0,19.92,9.62Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconArrowRight = IconArrowRight;
var IconBackToTop = (0, _createSvg.createSvg)('IconBackToTop', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M4 5H16a1 1 0 0 0 0-2H4A1 1 0 0 0 4 5zM10.71 9.29a1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 1.42 1.42L10 11.41l5.29 5.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconBackToTop = IconBackToTop;
var IconBin = (0, _createSvg.createSvg)('IconBin', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M5,18 L5,4 L15,4 L15,18 L5,18 Z M8,16 C8.553,16 9,15.553 9,15 L9,7 C9,6.447 8.553,6 8,6 C7.447,6 7,6.447 7,7 L7,15 C7,15.553 7.447,16 8,16 Z M12,16 C12.553,16 13,15.553 13,15 L13,7 C13,6.447 12.553,6 12,6 C11.447,6 11,6.447 11,7 L11,15 C11,15.553 11.447,16 12,16 Z M17,2 L16,2 L13,2 L13,1 C13,0.447 12.553,0 12,0 L8,0 C7.447,0 7,0.447 7,1 L7,2 L4,2 L3,2 C2.447,2 2,2.447 2,3 C2,3.553 2.447,4 3,4 L3,19 C3,19.553 3.447,20 4,20 L16,20 C16.553,20 17,19.553 17,19 L17,4 C17.553,4 18,3.553 18,3 C18,2.447 17.553,2 17,2 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconBin = IconBin;
var IconBold = (0, _createSvg.createSvg)('IconBold', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M5.41,16.24V3.76H9.89a4.43,4.43,0,0,1,2.91.92,3,3,0,0,1,1.11,2.39,2.87,2.87,0,0,1-.43,1.58,2.72,2.72,0,0,1-1.25,1A3.39,3.39,0,0,1,14,10.79a3.06,3.06,0,0,1,.6,1.92,3.08,3.08,0,0,1-1.21,2.57,5,5,0,0,1-3.24,1ZM8,5.69V9H9.53c1.17,0,1.75-.53,1.75-1.61a1.44,1.44,0,0,0-1.6-1.66ZM8,10.8v3.51h2.12c1.22,0,1.84-.58,1.84-1.73s-.66-1.78-2-1.78Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconBold = IconBold;
var IconCalendar = (0, _createSvg.createSvg)('IconCalendar', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M3,17 L17,17 L17,10 L3,10 L3,17 Z M6,5 L6,6 C6,6.553 6.448,7 7,7 C7.552,7 8,6.553 8,6 L8,5 L12,5 L12,6 C12,6.553 12.448,7 13,7 C13.553,7 14,6.553 14,6 L14,5 L17,5 L17,8 L3,8 L3,5 L6,5 Z M18,3 L14,3 L14,2 C14,1.447 13.553,1 13,1 C12.448,1 12,1.447 12,2 L12,3 L8,3 L8,2 C8,1.447 7.552,1 7,1 C6.448,1 6,1.447 6,2 L6,3 L2,3 C1.448,3 1,3.447 1,4 L1,18 C1,18.553 1.448,19 2,19 L18,19 C18.553,19 19,18.553 19,18 L19,4 C19,3.447 18.553,3 18,3 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconCalendar = IconCalendar;
var IconCheck = (0, _createSvg.createSvg)('IconCheck', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M9,13.99991 C8.735,13.99991 8.48,13.89591 8.293,13.70691 L5.293,10.70691 C4.902,10.31591 4.902,9.68391 5.293,9.29291 C5.684,8.90191 6.316,8.90191 6.707,9.29291 L8.933,11.51891 L13.231,6.35891 C13.585,5.93691 14.215,5.87791 14.641,6.23091 C15.064,6.58491 15.122,7.21591 14.769,7.64091 L9.769,13.64091 C9.588,13.85591 9.326,13.98591 9.045,13.99891 C9.03,13.99991 9.015,13.99991 9,13.99991'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconCheck = IconCheck;
var IconDesktop = (0, _createSvg.createSvg)('IconDesktop', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M19,1H1A1,1,0,0,0,0,2V14a1,1,0,0,0,1,1H6.72l-.5,2H5a1,1,0,0,0,0,2H15a1,1,0,0,0,0-2H13.78l-.5-2H19a1,1,0,0,0,1-1V2A1,1,0,0,0,19,1ZM11.72,17H8.28l.5-2h2.44ZM18,13H2V3H18Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconDesktop = IconDesktop;
var IconDisabled = (0, _createSvg.createSvg)('IconDisabled', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M15.6039211,5.81029248 L5.81029248,15.6039211 C6.97933765,16.4802797 8.43026749,17 10,17 C13.859,17 17,13.859 17,10 C17,8.43026749 16.4802797,6.97933765 15.6039211,5.81029248 Z M14.1897075,4.39607891 C13.0206624,3.51972031 11.5697325,3 10,3 C6.141,3 3,6.141 3,10 C3,11.5697325 3.51972031,13.0206624 4.39607891,14.1897075 L14.1897075,4.39607891 Z M10,1 C14.963,1 19,5.037 19,10 C19,14.963 14.963,19 10,19 C5.037,19 1,14.963 1,10 C1,5.037 5.037,1 10,1 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconDisabled = IconDisabled;
var IconDownload = (0, _createSvg.createSvg)('IconDownload', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,16 C16.553,16 17,16.447 17,17 L17,19 C17,19.553 16.553,20 16,20 L4,20 C3.447,20 3,19.553 3,19 L3,17 C3,16.447 3.447,16 4,16 C4.553,16 5,16.447 5,17 L5,18 L15,18 L15,17 C15,16.447 15.447,16 16,16 Z M9.292,14.7061 L5.293,10.7071 C4.902,10.3161 4.902,9.6841 5.293,9.2931 C5.684,8.9021 6.316,8.9021 6.707,9.2931 L9,11.5861 L9,1.0001 C9,0.4471 9.447,0.0001 10,0.0001 C10.553,0.0001 11,0.4471 11,1.0001 L11,11.5861 L13.293,9.2931 C13.684,8.9021 14.316,8.9021 14.707,9.2931 C15.098,9.6841 15.098,10.3161 14.707,10.7071 L10.708,14.7061 C10.616,14.7991 10.505,14.8721 10.382,14.9231 C10.26,14.9741 10.13,15.0001 10,15.0001 C9.87,15.0001 9.74,14.9741 9.618,14.9231 C9.495,14.8721 9.384,14.7991 9.292,14.7061 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconDownload = IconDownload;
var IconFocus = (0, _createSvg.createSvg)('IconFocus', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M4.02882095,14.5623116 L7.3223441,11.3291862 C7.71388901,10.9448216 8.3420127,10.9477279 8.72998408,11.3356993 L8.73649739,11.3422126 C9.12342448,11.7291397 9.12342448,12.3564724 8.73649739,12.7433995 C8.73433634,12.7455606 8.73216531,12.7477116 8.72998436,12.7498526 L5.41396642,16.0050602 L8.02882095,16.0050602 C8.5811057,16.0050602 9.02882095,16.4527755 9.02882095,17.0050602 C9.02882095,17.557345 8.5811057,18.0050602 8.02882095,18.0050602 L3.02882095,18.0050602 C2.4765362,18.0050602 2.02882095,17.557345 2.02882095,17.0050602 L2.02882095,12.0050602 C2.02882095,11.4527755 2.4765362,11.0050602 3.02882095,11.0050602 C3.5811057,11.0050602 4.02882095,11.4527755 4.02882095,12.0050602 L4.02882095,14.5623116 Z M16,5.44274859 L12.7064768,8.67587398 C12.3149319,9.0602386 11.6868082,9.05733233 11.2988369,8.66936095 L11.2923236,8.66284765 C10.9053965,8.27592055 10.9053965,7.64858779 11.2923236,7.2616607 C11.2944846,7.25949965 11.2966556,7.25734862 11.2988366,7.25520766 L14.6148545,4 L12,4 C11.4477153,4 11,3.55228475 11,3 C11,2.44771525 11.4477153,2 12,2 L17,2 C17.5522847,2 18,2.44771525 18,3 L18,8 C18,8.55228475 17.5522847,9 17,9 C16.4477153,9 16,8.55228475 16,8 L16,5.44274859 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconFocus = IconFocus;
var IconGlobe = (0, _createSvg.createSvg)('IconGlobe', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm7,8.25H14.73a12.91,12.91,0,0,0-1.3-5.34A7,7,0,0,1,17,9.25Zm-6.08,7.69-.13,0V10.75h2.48C13.08,13.84,12,16.14,10.88,16.94ZM6.77,10.75H9.25V17l-.13,0C8,16.14,6.92,13.84,6.77,10.75ZM9.12,3.06l.13,0V9.25H6.77C6.92,6.16,8,3.86,9.12,3.06Zm1.63,6.19V3l.13,0c1.15.8,2.2,3.1,2.35,6.19ZM6.57,3.91a12.91,12.91,0,0,0-1.3,5.34H3A7,7,0,0,1,6.57,3.91ZM3,10.75H5.27a12.91,12.91,0,0,0,1.3,5.34A7,7,0,0,1,3,10.75Zm10.39,5.34a12.91,12.91,0,0,0,1.3-5.34H17A7,7,0,0,1,13.43,16.09Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconGlobe = IconGlobe;
var IconHome = (0, _createSvg.createSvg)('IconHome', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M18.6,7.2l-8-6a1,1,0,0,0-1.2,0l-8,6A1,1,0,0,0,1,8V18a1,1,0,0,0,1,1H7.5a1,1,0,0,0,1-1V13h3v5a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V8A1,1,0,0,0,18.6,7.2ZM17,17H13.5V12a1,1,0,0,0-1-1h-5a1,1,0,0,0-1,1v5H3V8.5l7-5.25L17,8.5Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconHome = IconHome;
var IconHourGlass = (0, _createSvg.createSvg)('IconHourGlass', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M6,18 L6,16.218 L8.659,10.417 C8.78,10.152 8.78,9.848 8.659,9.583 L6,3.782 L6,2 L14,2 L14,3.782 L11.341,9.583 C11.22,9.848 11.22,10.152 11.341,10.417 L14,16.218 L14,18 L6,18 Z M16,18 C16.553,18 17,18.447 17,19 C17,19.553 16.553,20 16,20 L15,20 L5,20 L4,20 C3.447,20 3,19.553 3,19 C3,18.447 3.447,18 4,18 L4,16 C4,15.856 4.031,15.714 4.091,15.583 L6.65,10 L4.091,4.417 C4.031,4.286 4,4.144 4,4 L4,2 C3.447,2 3,1.553 3,1 C3,0.447 3.447,0 4,0 L5,0 L15,0 L16,0 C16.553,0 17,0.447 17,1 C17,1.553 16.553,2 16,2 L16,4 C16,4.144 15.969,4.286 15.909,4.417 L13.35,10 L15.909,15.583 C15.969,15.714 16,15.856 16,16 L16,18 Z M9.584,8.376 C9.782,8.673 10.218,8.673 10.416,8.376 L11.231,6.777 C11.453,6.445 11.215,6 10.815,6 L9.185,6 C8.785,6 8.547,6.445 8.769,6.777 L9.584,8.376 Z M10.7119,12.2217 C10.4829,11.5377 9.5169,11.5377 9.2879,12.2217 L7.5819,16.3417 C7.4739,16.6657 7.7149,16.9997 8.0559,16.9997 L11.9439,16.9997 C12.2849,16.9997 12.5259,16.6657 12.4179,16.3417 L10.7119,12.2217 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconHourGlass = IconHourGlass;
var IconItalic = (0, _createSvg.createSvg)('IconItalic', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M6.22,16.24l.23-.74a9.92,9.92,0,0,1,1.64-.58L10.18,5,9.06,4.82c-.25,0-.37-.15-.37-.32A1.76,1.76,0,0,1,9,3.76h4.82l-.23.74a9.92,9.92,0,0,1-1.64.58L9.82,15l1.12.22c.25,0,.37.15.37.32a1.76,1.76,0,0,1-.27.74Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconItalic = IconItalic;
var IconJumpToContent = (0, _createSvg.createSvg)('IconJumpToContent', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M15.71,12.76,12.17,9.22a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l1.86,1.86H6v-9a1,1,0,0,0-2,0v10a1,1,0,0,0,1,1h7.55l-1.79,1.79a1,1,0,0,0,1.41,1.42l3.43-3.43a1,1,0,0,0,.4-.78v0A1,1,0,0,0,15.71,12.76Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconJumpToContent = IconJumpToContent;
var IconMail = (0, _createSvg.createSvg)('IconMail', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M2,15 L2,6.045 L9.386,11.789 C9.566,11.93 9.783,12 10,12 C10.217,12 10.434,11.93 10.614,11.789 L18,6.045 L18,15 L2,15 Z M16.086,5 L10,9.733 L3.914,5 L16.086,5 Z M19.976,3.88 C19.968,3.812 19.958,3.746 19.936,3.68 C19.912,3.612 19.879,3.554 19.843,3.494 C19.822,3.459 19.815,3.419 19.789,3.386 C19.776,3.369 19.757,3.362 19.744,3.347 C19.697,3.293 19.643,3.253 19.585,3.211 C19.536,3.174 19.49,3.137 19.437,3.11 C19.381,3.083 19.322,3.069 19.262,3.053 C19.194,3.034 19.129,3.017 19.06,3.012 C19.039,3.011 19.021,3 19,3 L1,3 C0.979,3 0.962,3.011 0.94,3.012 C0.871,3.017 0.807,3.034 0.739,3.053 C0.679,3.069 0.619,3.083 0.563,3.11 C0.51,3.137 0.465,3.174 0.416,3.209 C0.358,3.252 0.304,3.293 0.256,3.347 C0.242,3.362 0.224,3.369 0.211,3.386 C0.185,3.419 0.178,3.459 0.156,3.494 C0.121,3.555 0.088,3.612 0.064,3.679 C0.042,3.746 0.032,3.812 0.024,3.88 C0.02,3.921 0,3.957 0,4 L0,16 C0,16.553 0.447,17 1,17 L19,17 C19.553,17 20,16.553 20,16 L20,4 C20,3.957 19.98,3.921 19.976,3.88 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconMail = IconMail;
var IconMenu = (0, _createSvg.createSvg)('IconMenu', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M2 5H18a1 1 0 0 0 0-2H2A1 1 0 0 0 2 5zM18 15H2a1 1 0 0 0 0 2H18a1 1 0 0 0 0-2zM18 9H2a1 1 0 0 0 0 2H18a1 1 0 0 0 0-2z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconMenu = IconMenu;
var IconMobile = (0, _createSvg.createSvg)('IconMobile', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M14,3H6A1,1,0,0,0,5,4V18a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V4A1,1,0,0,0,14,3ZM13,17H7V5h6Z', 'M9.29,15.7a.91.91,0,0,0,.33.22,1,1,0,0,0,1.3-1.3,1,1,0,0,0-.21-.33l-.15-.12-.18-.09a.6.6,0,0,0-.19-.06,1,1,0,0,0-.9.27,1.15,1.15,0,0,0-.21.33.94.94,0,0,0,0,.76A1,1,0,0,0,9.29,15.7Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconMobile = IconMobile;
var IconMoreHorizontal = (0, _createSvg.createSvg)('IconMoreHorizontal', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M2,8 C3.104,8 4,8.896 4,10 C4,11.104 3.104,12 2,12 C0.896,12 0,11.104 0,10 C0,8.896 0.896,8 2,8 Z M10,8 C11.104,8 12,8.896 12,10 C12,11.104 11.104,12 10,12 C8.896,12 8,11.104 8,10 C8,8.896 8.896,8 10,8 Z M18,8 C19.104,8 20,8.896 20,10 C20,11.104 19.104,12 18,12 C16.896,12 16,11.104 16,10 C16,8.896 16.896,8 18,8 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconMoreHorizontal = IconMoreHorizontal;
var IconMoreVertical = (0, _createSvg.createSvg)('IconMoreVertical', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M8,18 C8,16.896 8.896,16 10,16 C11.104,16 12,16.896 12,18 C12,19.104 11.104,20 10,20 C8.896,20 8,19.104 8,18 Z M8,10 C8,8.896 8.896,8 10,8 C11.104,8 12,8.896 12,10 C12,11.104 11.104,12 10,12 C8.896,12 8,11.104 8,10 Z M8,2 C8,0.896 8.896,0 10,0 C11.104,0 12,0.896 12,2 C12,3.104 11.104,4 10,4 C8.896,4 8,3.104 8,2 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconMoreVertical = IconMoreVertical;
var IconPadlock = (0, _createSvg.createSvg)('IconPadlock', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M5,17 L15,17 L15,9 L5,9 L5,17 Z M8,5 C8,3.897 8.897,3 10,3 C11.103,3 12,3.897 12,5 L12,7 L8,7 L8,5 Z M16,7 C16.553,7 17,7.447 17,8 L17,18 C17,18.553 16.553,19 16,19 L4,19 C3.447,19 3,18.553 3,18 L3,8 C3,7.447 3.447,7 4,7 L6,7 L6,5 C6,2.794 7.794,1 10,1 C12.206,1 14,2.794 14,5 L14,7 L16,7 Z M10,11 C9.447,11 9,11.447 9,12 L9,14 C9,14.553 9.447,15 10,15 C10.553,15 11,14.553 11,14 L11,12 C11,11.447 10.553,11 10,11 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconPadlock = IconPadlock;
var IconPencil = (0, _createSvg.createSvg)('IconPencil', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M4.90216832,13.512 L11.0001683,7.414 L12.5861683,9 L6.48816832,15.098 L4.37416832,15.626 L4.90216832,13.512 Z M14.0001683,7.586 L12.4141683,6 L14.0001683,4.414 L15.5861683,6 L14.0001683,7.586 Z M17.7071683,5.293 L14.7071683,2.293 C14.3161683,1.903 13.6831683,1.903 13.2931683,2.293 L3.29316832,12.293 C3.27716832,12.309 3.27116832,12.33 3.25616832,12.348 C3.21216832,12.399 3.17716832,12.456 3.14416832,12.518 C3.11016832,12.576 3.07916832,12.634 3.05816832,12.698 C3.05116832,12.719 3.03616832,12.736 3.03016832,12.758 L2.03016832,16.758 C1.94416832,17.099 2.04516832,17.459 2.29316832,17.707 C2.48216832,17.897 2.73816832,18 3.00016832,18 C3.08116832,18 3.16216832,17.991 3.24216832,17.97 L7.24216832,16.97 C7.26416832,16.964 7.28016832,16.949 7.30216832,16.942 C7.36716832,16.921 7.42516832,16.889 7.48616832,16.854 C7.54416832,16.821 7.59916832,16.789 7.64916832,16.745 C7.66816832,16.73 7.69016832,16.724 7.70716832,16.707 L17.7071683,6.707 C18.0971683,6.317 18.0971683,5.684 17.7071683,5.293 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconPencil = IconPencil;
var IconPerson = (0, _createSvg.createSvg)('IconPerson', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,17 L3.998,17 L3.997,16.076 C4.271,12.499 6.738,10 10,10 C13.25,10 15.713,12.481 16,16.039 L16,17 Z M7.5,5.5 C7.5,4.121 8.621,3 10,3 C11.379,3 12.5,4.121 12.5,5.5 C12.5,6.879 11.379,8 10,8 C8.621,8 7.5,6.879 7.5,5.5 Z M17.997,15.924 C17.735,12.495 15.887,9.832 13.199,8.658 C14.002,7.846 14.5,6.73 14.5,5.5 C14.5,3.019 12.481,1 10,1 C7.519,1 5.5,3.019 5.5,5.5 C5.5,6.73 5.998,7.846 6.802,8.659 C4.114,9.837 2.264,12.516 2,16 L2,18 C2,18.553 2.447,19 3,19 L17,19 C17.553,19 18,18.553 18,18 L18,16 C18,15.975 17.999,15.949 17.997,15.924 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconPerson = IconPerson;
var IconPhone = (0, _createSvg.createSvg)('IconPhone', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M15,19H14A13,13,0,0,1,1,6V5C1,2.82,2.23.5,4.5.5a1,1,0,0,1,.71.29l3.5,3.5a1,1,0,0,1,0,1.42l-2,2a12.3,12.3,0,0,0,5.59,5.59l2-2a1,1,0,0,1,1.42,0l3.5,3.5a1,1,0,0,1,.29.71C19.5,17.77,17.18,19,15,19ZM4.15,2.56C3.36,2.85,3,4.09,3,5V6A11,11,0,0,0,14,17h1c.91,0,2.15-.36,2.44-1.15L15,13.41l-1.79,1.8a1,1,0,0,1-1.08.22A14.2,14.2,0,0,1,4.57,7.87a1,1,0,0,1,.22-1.08L6.59,5Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconPhone = IconPhone;
var IconPlay = (0, _createSvg.createSvg)('IconPlay', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M10,17 C6.140375,17 3,13.859625 3,10 C3,6.140375 6.140375,3 10,3 C13.859625,3 17,6.140375 17,10 C17,13.859625 13.859625,17 10,17 M10,1 C14.9626,1 19,5.0374 19,10 C19,14.9626 14.9626,19 10,19 C5.0374,19 1,14.9626 1,10 C1,5.0374 5.0374,1 10,1 Z M13.0811,9.1865 L9.5811,6.6865 C9.2761,6.4675 8.8751,6.4405 8.5421,6.6105 C8.2091,6.7825 8.0001,7.1245 8.0001,7.4995 L8.0001,12.4995 C8.0001,12.8745 8.2091,13.2175 8.5421,13.3895 C8.6861,13.4635 8.8441,13.4995 9.0001,13.4995 C9.2051,13.4995 9.4081,13.4375 9.5811,13.3135 L13.0811,10.8135 C13.3441,10.6255 13.5001,10.3235 13.5001,9.9995 C13.5001,9.6765 13.3441,9.3735 13.0811,9.1865 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconPlay = IconPlay;
var IconPrinter = (0, _createSvg.createSvg)('IconPrinter', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M17,14 L15,14 L15,12 C15,11.447 14.553,11 14,11 L6,11 C5.447,11 5,11.447 5,12 L5,14 L3,14 L3,8 L6,8 L14,8 L17,8 L17,14 Z M7,17 L13,17 L13,13 L7,13 L7,17 Z M7,6 L13,6 L13,3 L7,3 L7,6 Z M18,6 L15,6 L15,2 C15,1.447 14.553,1 14,1 L6,1 C5.447,1 5,1.447 5,2 L5,6 L2,6 C1.447,6 1,6.447 1,7 L1,15 C1,15.553 1.447,16 2,16 L5,16 L5,18 C5,18.553 5.447,19 6,19 L14,19 C14.553,19 15,18.553 15,18 L15,16 L18,16 C18.553,16 19,15.553 19,15 L19,7 C19,6.447 18.553,6 18,6 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconPrinter = IconPrinter;
var IconRedo = (0, _createSvg.createSvg)('IconRedo', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M19,7a1,1,0,0,0-.4-.78L15.17,2.79a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15.55,6H7A6,6,0,0,0,7,18h3a1,1,0,0,0,0-2H7A4,4,0,0,1,7,8h8.62L13.76,9.86a1,1,0,0,0,1.41,1.42l3.54-3.54A1,1,0,0,0,19,7Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconRedo = IconRedo;
var IconRefresh = (0, _createSvg.createSvg)('IconRefresh', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M10 1.1c-2.1 0-4.1.8-5.7 2.1L3.4 2.5C3.2 2.3 2.7 2.3 2.4 2.4 2.1 2.6 1.9 3 1.9 3.3L2 6.3c0 .3.2.5.4.7C2.6 7.1 2.8 7.2 3 7.2c0 0 .1 0 .1 0l3-.4C6.5 6.7 6.8 6.4 6.9 6c.1-.4 0-.8-.3-1L5.7 4.3C6.9 3.4 8.4 2.9 10 2.9c3.6 0 6.6 2.7 7 6.2.1.4.4.8.9.8 0 0 .1 0 .1 0 .5-.1.8-.5.8-1C18.3 4.5 14.5 1.1 10 1.1zM17.6 13c-.2-.2-.5-.2-.8-.2l-3 .4c-.4.1-.7.4-.8.7-.1.4 0 .8.3 1l.9.7c-1.2.9-2.7 1.4-4.3 1.4-3.6 0-6.6-2.7-7-6.2-.1-.5-.5-.8-1-.8-.5.1-.8.5-.8 1 .6 4.4 4.3 7.8 8.8 7.8 2.1 0 4.1-.8 5.7-2.1l.8.7c.2.1.4.2.6.2.2 0 .3 0 .4-.1.3-.2.5-.6.5-.9l-.2-2.9C17.9 13.5 17.8 13.2 17.6 13z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconRefresh = IconRefresh;
var IconReset = (0, _createSvg.createSvg)('IconReset', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M10,1.1c-2.1,0-4.1,0.8-5.7,2.1L3.4,2.5C3.2,2.3,2.7,2.3,2.4,2.4C2.1,2.6,1.9,3,1.9,3.3L2,6.3 c0,0.3,0.2,0.5,0.4,0.7C2.6,7.1,2.8,7.2,3,7.2c0,0,0.1,0,0.1,0l3-0.4C6.5,6.7,6.8,6.4,6.9,6c0.1-0.4,0-0.8-0.3-1L5.7,4.3 C6.9,3.4,8.4,2.9,10,2.9c3.9,0,7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1c-3.7,0-6.9-2.9-7.1-6.7C2.9,10,2.5,9.6,2,9.6 c-0.5,0-0.9,0.5-0.8,0.9c0.3,4.7,4.2,8.3,8.9,8.3c4.9,0,8.9-4,8.9-8.9S14.9,1.1,10,1.1z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconReset = IconReset;
var IconSettings = (0, _createSvg.createSvg)('IconSettings', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16.1289,10 C16.1289,10.593 16.0409,11.164 15.8899,11.71 L17.4569,12.614 L15.8569,15.386 L14.2899,14.481 C13.4879,15.297 12.4689,15.895 11.3279,16.189 L11.3279,18 L8.1289,18 L8.1289,16.189 C6.9879,15.895 5.9689,15.297 5.1669,14.481 L3.6009,15.386 L1.9999,12.614 L3.5669,11.71 C3.4159,11.164 3.3279,10.593 3.3279,10 C3.3279,9.407 3.4159,8.836 3.5669,8.29 L1.9999,7.386 L3.6009,4.614 L5.1669,5.519 C5.9689,4.703 6.9879,4.105 8.1289,3.811 L8.1289,2 L11.3279,2 L11.3279,3.811 C12.4689,4.105 13.4879,4.703 14.2899,5.519 L15.8569,4.614 L17.4569,7.386 L15.8899,8.29 C16.0409,8.836 16.1289,9.407 16.1289,10 M18.4569,10.883 C19.4129,11.435 19.7409,12.658 19.1889,13.614 L17.5889,16.386 C17.2189,17.027 16.5459,17.386 15.8549,17.386 C15.5159,17.386 15.1719,17.3 14.8569,17.117 L14.4949,16.909 C14.1249,17.164 13.7349,17.389 13.3279,17.582 L13.3279,18 C13.3279,19.104 12.4329,20 11.3279,20 L8.1289,20 C7.0239,20 6.1289,19.104 6.1289,18 L6.1289,17.582 C5.7219,17.389 5.3319,17.164 4.9619,16.909 L4.6009,17.117 C4.2849,17.3 3.9409,17.386 3.6029,17.386 C2.9109,17.386 2.2379,17.027 1.8679,16.386 L0.2689,13.614 C-0.2841,12.658 0.0439,11.435 0.9999,10.883 L1.3579,10.677 C1.3379,10.45 1.3279,10.225 1.3279,10 C1.3279,9.775 1.3379,9.55 1.3579,9.323 L0.9999,9.117 C0.0439,8.565 -0.2841,7.342 0.2689,6.386 L1.8679,3.614 C2.2379,2.973 2.9109,2.614 3.6029,2.614 C3.9409,2.614 4.2849,2.7 4.6009,2.883 L4.9619,3.091 C5.3319,2.836 5.7219,2.611 6.1289,2.418 L6.1289,2 C6.1289,0.896 7.0239,0 8.1289,0 L11.3279,0 C12.4329,0 13.3279,0.896 13.3279,2 L13.3279,2.418 C13.7349,2.611 14.1249,2.836 14.4949,3.091 L14.8569,2.883 C15.1719,2.7 15.5159,2.614 15.8549,2.614 C16.5459,2.614 17.2189,2.973 17.5889,3.614 L19.1889,6.386 C19.7409,7.342 19.4129,8.565 18.4569,9.117 L18.0999,9.323 C18.1189,9.55 18.1289,9.775 18.1289,10 C18.1289,10.225 18.1189,10.45 18.0999,10.677 L18.4569,10.883 Z M9.7285,8 C8.6245,8 7.7285,8.896 7.7285,10 C7.7285,11.104 8.6245,12 9.7285,12 C10.8325,12 11.7285,11.104 11.7285,10 C11.7285,8.896 10.8325,8 9.7285,8 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconSettings = IconSettings;
var IconTablet = (0, _createSvg.createSvg)('IconTablet', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,1H4A1,1,0,0,0,3,2V18a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V2A1,1,0,0,0,16,1ZM15,17H5V3H15Z', 'M9.29,15.7a.91.91,0,0,0,.33.22,1,1,0,0,0,1.3-1.3,1,1,0,0,0-.21-.33l-.15-.12-.18-.09a.6.6,0,0,0-.19-.06,1,1,0,0,0-.9.27,1.15,1.15,0,0,0-.21.33.94.94,0,0,0,0,.76A1,1,0,0,0,9.29,15.7Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconTablet = IconTablet;
var IconThumbDownFill = (0, _createSvg.createSvg)('IconThumbDownFill', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M18.55,0A1.45,1.45,0,0,1,20,1.45V9a1.45,1.45,0,0,1-1.45,1.45h-2.3A1.45,1.45,0,0,1,14.8,9V1.45A1.45,1.45,0,0,1,16.25,0ZM2.81,0h1c1.64,0,3.34,0,5,.11.85.05,1.69.19,2.51.32.39.06.9.15,1.37.21a.92.92,0,0,1,.78.94V9.83a.92.92,0,0,1-.58.88,1.35,1.35,0,0,0-.77.89A9.44,9.44,0,0,1,9.72,15a4.66,4.66,0,0,0-1.08,2.48c-.1.57-.21,1.11-.34,1.62a1.23,1.23,0,0,1-.57.84.86.86,0,0,1-.39.09,1.48,1.48,0,0,1-.58-.14,2.5,2.5,0,0,1-1.44-2.33,9,9,0,0,1,.52-3.12c.08-.24.16-.48.23-.72s.21-.63.3-.95,0-.3.06-.31a.8.8,0,0,0-.32,0H2.25a3.54,3.54,0,0,1-.79-.1A2,2,0,0,1,.71,8.84l0,0,0,0A2.13,2.13,0,0,1,0,7,1.72,1.72,0,0,1,.68,5.69a1.93,1.93,0,0,1,.4-3.15,3.3,3.3,0,0,1,.49-.19A1.68,1.68,0,0,1,1.5.73,1.41,1.41,0,0,1,2.8,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconThumbDownFill = IconThumbDownFill;
var IconThumbDown = (0, _createSvg.createSvg)('IconThumbDown', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M18.45.49H16A1.53,1.53,0,0,0,15,.9,11.89,11.89,0,0,0,13.29.58C12.85.53,12.37.46,12,.4A21.73,21.73,0,0,0,9.51.1C7.88,0,6.24,0,4.65,0h-1A2.39,2.39,0,0,0,1.56,1.16a2.37,2.37,0,0,0-.28,1.41,2.72,2.72,0,0,0-1.23,2A2.73,2.73,0,0,0,.36,6.08,2.62,2.62,0,0,0,0,7.22,2.92,2.92,0,0,0,.4,8.94a2.54,2.54,0,0,0-.3,2,2.78,2.78,0,0,0,2,2.09,3.94,3.94,0,0,0,1,.12H5.81c0,.17-.11.34-.17.52a8.58,8.58,0,0,0-.54,3.16,3.25,3.25,0,0,0,2,3A2.44,2.44,0,0,0,8,20a1.77,1.77,0,0,0,.82-.19,2,2,0,0,0,1.07-1.39c.13-.48.25-1,.35-1.53A3.1,3.1,0,0,1,11,15.17l.41-.42a8,8,0,0,0,2.11-2.95.77.77,0,0,1,.12-.2l.24-.08c.38-.1.75-.21,1.09-.33a1.55,1.55,0,0,0,1,.38h2.44A1.54,1.54,0,0,0,20,10V2A1.54,1.54,0,0,0,18.45.49Zm-5.08,9.1-.33.1a2.18,2.18,0,0,0-1.35,1.38A6.28,6.28,0,0,1,10,13.34l-.43.44a5,5,0,0,0-1.3,2.74c-.09.49-.2.95-.31,1.38L8,18l-.08,0a1.19,1.19,0,0,1-.77-1.22,6.7,6.7,0,0,1,.45-2.44c.07-.2.13-.4.2-.6l0-.12.27-.8c0-.16.07-.27.08-.35a1.14,1.14,0,0,0,0-.45,1,1,0,0,0-.59-.69,1.68,1.68,0,0,0-.69-.12H3.16a2.11,2.11,0,0,1-.49-.05.82.82,0,0,1-.62-.63c0-.2,0-.44.3-.75h0a1,1,0,0,0,.33-.8,1,1,0,0,0-.4-.78A.86.86,0,0,1,2,7.38.5.5,0,0,1,2.21,7a1,1,0,0,0,.45-.77,1,1,0,0,0-.34-.83.7.7,0,0,1-.26-.61.71.71,0,0,1,.43-.57,1,1,0,0,1,.29-.1,1,1,0,0,0,.67-.59,1,1,0,0,0-.07-.89.52.52,0,0,1-.07-.45A.45.45,0,0,1,3.69,2h1C6.21,2,7.82,2,9.4,2.1c.76,0,1.54.17,2.3.28l1.34.2a10.58,10.58,0,0,1,1.43.26V9.25C14.23,9.34,13.86,9.45,13.37,9.59Zm3.13,0H18V2.5H16.5Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconThumbDown = IconThumbDown;
var IconThumbUpFill = (0, _createSvg.createSvg)('IconThumbUpFill', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M1.45,20A1.45,1.45,0,0,1,0,18.55V11A1.45,1.45,0,0,1,1.45,9.56h2.3A1.45,1.45,0,0,1,5.2,11v7.54A1.45,1.45,0,0,1,3.75,20Zm15.74,0h-1c-1.64,0-3.34,0-5-.11-.85-.05-1.69-.19-2.51-.32-.39-.06-.9-.15-1.37-.21a.92.92,0,0,1-.78-.94V10.17a.92.92,0,0,1,.58-.88,1.35,1.35,0,0,0,.77-.89A9.44,9.44,0,0,1,10.28,5a4.66,4.66,0,0,0,1.08-2.48c.1-.57.21-1.11.34-1.62a1.23,1.23,0,0,1,.57-.84A.86.86,0,0,1,12.66,0a1.48,1.48,0,0,1,.58.14,2.5,2.5,0,0,1,1.44,2.33,9,9,0,0,1-.52,3.12c-.08.24-.16.48-.23.72s-.21.63-.3,1-.05.3-.06.31a.8.8,0,0,0,.32,0h3.86a3.54,3.54,0,0,1,.79.1,2,2,0,0,1,.75,3.45l0,0,0,0A2.13,2.13,0,0,1,20,13a1.72,1.72,0,0,1-.67,1.31,1.93,1.93,0,0,1-.4,3.15,3.3,3.3,0,0,1-.49.19,1.68,1.68,0,0,1,.07,1.62,1.41,1.41,0,0,1-1.3.73Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconThumbUpFill = IconThumbUpFill;
var IconThumbUp = (0, _createSvg.createSvg)('IconThumbUp', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M19.6,11.06a2.54,2.54,0,0,0,.3-2,2.78,2.78,0,0,0-2-2.09,3.81,3.81,0,0,0-1-.12H14.19c.05-.17.11-.34.17-.52a8.58,8.58,0,0,0,.54-3.16,3.25,3.25,0,0,0-2-3,2.11,2.11,0,0,0-1.77,0,2.09,2.09,0,0,0-1.08,1.4c-.12.48-.24,1-.34,1.53A3.1,3.1,0,0,1,9,4.83l-.41.42A8,8,0,0,0,6.44,8.2c-.07.15-.11.2-.11.21l-.25.07c-.38.1-.75.21-1.09.33a1.55,1.55,0,0,0-1-.38H1.55A1.54,1.54,0,0,0,0,10v8a1.54,1.54,0,0,0,1.55,1.54H4a1.52,1.52,0,0,0,1-.41,11.09,11.09,0,0,0,1.69.32c.44,0,.92.12,1.29.18a21.73,21.73,0,0,0,2.49.3c1.63.09,3.27.09,4.85.1h1a2.39,2.39,0,0,0,2.13-1.16,2.3,2.3,0,0,0,.27-1.41,2.7,2.7,0,0,0,1.24-2,2.73,2.73,0,0,0-.31-1.54A2.62,2.62,0,0,0,20,12.77,2.91,2.91,0,0,0,19.6,11.06ZM2,17.5H3.5V10.44H2Zm15.67-2.87a.7.7,0,0,1,.26.61.71.71,0,0,1-.43.57,1.06,1.06,0,0,1-.3.1,1,1,0,0,0-.66.59,1,1,0,0,0,.07.89.52.52,0,0,1,.07.45.45.45,0,0,1-.38.15h-1c-1.56,0-3.17,0-4.75-.09-.76,0-1.54-.17-2.3-.28L7,17.42a10.58,10.58,0,0,1-1.43-.26V10.75c.24-.09.61-.2,1.1-.34l.33-.1A2.18,2.18,0,0,0,8.31,8.93,6.25,6.25,0,0,1,10,6.66l.43-.44a5.07,5.07,0,0,0,1.3-2.74c.09-.49.2-1,.31-1.38A.25.25,0,0,0,12,2l.08,0a1.22,1.22,0,0,1,.77,1.23,6.7,6.7,0,0,1-.45,2.44c-.07.21-.14.41-.21.64s-.21.59-.3.88-.07.28-.08.35a1.14,1.14,0,0,0,0,.45,1,1,0,0,0,.59.69,1.68,1.68,0,0,0,.69.12h3.71a2.11,2.11,0,0,1,.49.05.83.83,0,0,1,.62.63.71.71,0,0,1-.3.75h0a1,1,0,0,0,.07,1.58.88.88,0,0,1,.28.74.5.5,0,0,1-.19.41,1,1,0,0,0-.45.77A1,1,0,0,0,17.68,14.63Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconThumbUp = IconThumbUp;
var IconUnderline = (0, _createSvg.createSvg)('IconUnderline', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M13.08 3.42h1.83v7.92a4.87 4.87 0 0 1-1.26 3.6A5 5 0 0 1 10 16.2 5 5 0 0 1 6.35 15a4.86 4.86 0 0 1-1.26-3.61V3.42H6.92V11.5a3.28 3.28 0 0 0 .79 2.34 3.06 3.06 0 0 0 2.29.81 3.06 3.06 0 0 0 2.29-.81 3.28 3.28 0 0 0 .79-2.34zM3.65 18.58V17.14h12.7v1.44z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconUnderline = IconUnderline;
var IconUndo = (0, _createSvg.createSvg)('IconUndo', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M13,6H4.45L6.24,4.21a1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0L1.4,6.22A1,1,0,0,0,1,7V7a1,1,0,0,0,.29.72l3.54,3.54A1,1,0,1,0,6.24,9.86L4.38,8H13a4,4,0,0,1,0,8H10a1,1,0,0,0,0,2h3A6,6,0,0,0,13,6Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));
exports.IconUndo = IconUndo;
var IconUnfocus = (0, _createSvg.createSvg)('IconUnfocus', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M7.02882095,14.4478088 L3.73529779,17.6809342 C3.34375289,18.0652988 2.71562919,18.0623926 2.32765781,17.6744212 L2.3211445,17.6679079 C1.93421741,17.2809808 1.93421741,16.653648 2.3211445,16.2667209 C2.32330555,16.2645599 2.32547658,16.2624088 2.32765753,16.2602679 L5.64367547,13.0050602 L3.02882095,13.0050602 C2.4765362,13.0050602 2.02882095,12.557345 2.02882095,12.0050602 C2.02882095,11.4527755 2.4765362,11.0050602 3.02882095,11.0050602 L8.02882095,11.0050602 C8.5811057,11.0050602 9.02882095,11.4527755 9.02882095,12.0050602 L9.02882095,17.0050602 C9.02882095,17.557345 8.5811057,18.0050602 8.02882095,18.0050602 C7.4765362,18.0050602 7.02882095,17.557345 7.02882095,17.0050602 L7.02882095,14.4478088 Z M13,5.55725141 L16.2935232,2.32412602 C16.6850681,1.9397614 17.3131918,1.94266767 17.7011631,2.33063905 L17.7076764,2.33715235 C18.0946035,2.72407945 18.0946035,3.35141221 17.7076764,3.7383393 C17.7055154,3.74050035 17.7033444,3.74265138 17.7011634,3.74479234 L14.3851455,7 L17,7 C17.5522847,7 18,7.44771525 18,8 C18,8.55228475 17.5522847,9 17,9 L12,9 C11.4477153,9 11,8.55228475 11,8 L11,3 C11,2.44771525 11.4477153,2 12,2 C12.5522847,2 13,2.44771525 13,3 L13,5.55725141 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconUnfocus = IconUnfocus;
var IconUpload = (0, _createSvg.createSvg)('IconUpload', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,15.9987 C16.553,15.9987 17,16.4457 17,16.9987 L17,18.9987 C17,19.5517 16.553,19.9987 16,19.9987 L4,19.9987 C3.447,19.9987 3,19.5517 3,18.9987 L3,16.9987 C3,16.4457 3.447,15.9987 4,15.9987 C4.553,15.9987 5,16.4457 5,16.9987 L5,17.9987 L15,17.9987 L15,16.9987 C15,16.4457 15.447,15.9987 16,15.9987 Z M6.707,5.7057 C6.316,6.0967 5.684,6.0967 5.293,5.7057 C4.902,5.3147 4.902,4.6827 5.293,4.2917 L9.292,0.2927 C9.384,0.1997 9.495,0.1267 9.618,0.0757 C9.862,-0.0253 10.138,-0.0253 10.382,0.0757 C10.505,0.1267 10.616,0.1997 10.708,0.2927 L14.707,4.2917 C15.098,4.6827 15.098,5.3147 14.707,5.7057 C14.512,5.9007 14.256,5.9987 14,5.9987 C13.744,5.9987 13.488,5.9007 13.293,5.7057 L11,3.4127 L11,14.9987 C11,15.5517 10.553,15.9987 10,15.9987 C9.447,15.9987 9,15.5517 9,14.9987 L9,3.4127 L6.707,5.7057 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));
exports.IconUpload = IconUpload;